import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  FormLabel,
  FormControl,
  Row,
  Table,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import noImage from "../images/clicktoAdd.png";
import {
  DEFAULT_WAREHOUSE,
  NEW_ENTRY,
  MAIN_IMAGE_PART,
  WEB_IMAGE_PART,
  FRONT_IMAGE_PART,
  BACK_IMAGE_PART,
  DOCUMENT_CHANGED,
} from "../ds/App_Constants";
import {
  BaseBean,
  NodeData,
  RestReportBean,
  LogisticOrderReceiptRollLineBeanFilter,
} from "../ds/client_ds.js";
import {
  InvoiceServiceLineBean,
  LogisticOrderReceiptBean,
  LogisticOrderReceiptLineBean,
  LogisticOrderReceiptModuleDependenciesBean,
  LogisticOrderReceiptRollLineBean,
  LogisticOrderReceiptSearchCriteria,
  LogisticOrderSearchCriteria,
  LogisticReceiptToInvoiceInputBean,
  PageListBean,
  ReasonBean,
  RestEntityPrintRequest,
  RestEntityUnLockRequest,
  RestLogisticOrderListRequest,
  RestLogisticOrderReceiptListRequest,
  RestLogisticOrderReceiptRequest,
  RestLogisticReceiptRollLineExcelImportRequest,
  RestReadRequest,
  LogisticOrderReceiptDocumentBean,
  LogisticOrderReceiptImageBean,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import {
  CameraIcon,
  DeleteIcon,
  DropDwnDown,
  DropDwnUp,
  ExcelIcon,
  UploadDocIcon,
} from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DatePickerComponent,
  DatePickerComponent_adv,
  InputTextbox,
  MessageBoxComponent,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ReasonCaptureComponent,
  ShowError,
  ShortCutMenuPopup,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toFormattedDate_v1,
} from "../gui_components/Util.js";
import {
  PopupFabricInventoryPositionInq,
  PopupFabricPurchaseHistoryInq,
  PopupItemCurrentInventoryInq,
} from "../Inquiry/InquiryUtil.js";
import { PopupFabricModule } from "../modules/ModuleUtil.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { LogisticOrderLookupHandler } from "../lookup/LogisticOrderLookupHandler.js";
import { LogisticReceiptLookupHandler } from "../lookup/LogisticReceiptLookupHandler.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { LogisticOrderReceiptService } from "../services/LogisticOrderReceiptService.js";
import { LogisticOrderService } from "../services/LogisticOrderService.js";
import { ReportService } from "../services/ReportService.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { PopupInvoiceModule, PopupLogisticOrderModule } from "./ModuleUtil.js";
import { ModuleUtils } from "./ModuleUtils.js";
class LogisticReceipt extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "InBound Receipt",
      isLogisticReceiptEntryFormOpen: false,
      isLogisticReceiptListFormOpen: false,
      isLogisticReceiptHistoryFormOpen: false,
      isLogisticReceiptInvoiceFormOpen: false,
      isLogisticReceiptImageFormOpen: false,
      isLogisticReceiptDocumentFormOpen: false,
      isShowNodes: false,
      isShowSaveButton: false,
      isShowClearErrorButton: false,
      isShowPDFReportButton: false,
      isShowExcelButton: false,
      error_list: [],
      selectedNodeKey: "headerView",
      nodeList: [],
      isResetModule: false,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      moduleKeyCode: NEW_ENTRY,
      isResetView: true,
      isMaintenanceMode: true,
      isShowModuleSearchContainer: false,
      order: "",
      sortField: "",
      logisticReceiptData: new LogisticOrderReceiptBean(),
      logisticReceiptLineData: new LogisticOrderReceiptLineBean(),
      dependenciesBean: new LogisticOrderReceiptModuleDependenciesBean(),
      criteria: new LogisticOrderReceiptSearchCriteria(),
      pageList: new PageListBean(),
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      logisticReceiptLookupHandler: null,
      is3PL: false,

      wareHouses: new Array(),
      unapprovalReasons: new Array(),
      cancelReasons: new Array(),
      isShowAutoCompleteLocationList: false,
      locationPageListForAutoCompleteList: new Array(),

      isShowUnApproveButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isShowCreateInvoiceButton: false,
      isShowBasedonInvoices: false,
      isShowLinePopup: false,
      isShowAlertLvl1: false,

      isShowRollLinePopup: false,
      isShowAlertLvl5: false,

      logisticReceiptRollLineData: new LogisticOrderReceiptRollLineBean(),

      logisticReceipt_list: new Array(),
      receiptRollLines: new Array(),

      isShowAutoCompleteRollLineLocationList: false,
      rollLinelocationPageListForAutoCompleteList: new Array(),

      isShowAutoCompleteLogisticOrderList: false,
      logisticOrderPageListForAutoCompleteList: new Array(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",

      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),

      isShowCancelReasonPopup: false,
      isShowUnApproveReasonPopup: false,
      reasonData: new ReasonBean(),
      moduleOrderStatus: "",
      isShowLogisticOrderModule: false,
      moduleForPopup: [],

      isShowCreateInvoicePopup: false,
      isShowPopupAlertlvl2: false,
      invoiceServiceLineList: [],
      services: [],
      invoiceServiceLineData: new InvoiceServiceLineBean(),
      isShowAutoCompleteServiceList: false,
      servicePageListForAutoCompleteList: new Array(),
      customerServicesList: new Array(),
      isReseted: false,
      isViewMode: false,
      isDisabledFields: false,

      invoiceWarningMessage: "",
      isShowWarningMsgPopup: false,
      selectedDocument: "",

      invList: new Array(),

      isShowItemImagePopup: false,
      mainImageUrl: "",
      webImageUrl: "",
      frontImageUrl: "",
      backImageUrl: "",
      mainImgData: null,
      webImgData: null,
      frontImgData: null,
      BackImgData: null,

      isShowItemDocPopup: false,
      doc1Url: "",
      doc2Url: "",
      doc3Url: "",
      doc4Url: "",
      doc1Name: "",
      doc2Name: "",
      doc3Name: "",
      doc4Name: "",
      doc1Data: null,
      doc2Data: null,
      doc3Data: null,
      doc4Data: null,
      disableUpdatableFields: false,
      logisticReceiptRollLineBeanFilter:
        new LogisticOrderReceiptRollLineBeanFilter(),
      isSearchCriteria: false,
      isResetCriteria: true,
      isShowFilterList: false,
      filterLogisticReceiptList: [],

      images: [],
      preview_Url: [],
      isImageFormOpened: false,
      tempIndex: null,

      documents: [],
      preview_Docs: [],
      isImageFormOpened: false,
      tempIndex: null,

      isShowFabricModule: false,
      isShowItemInventoryPositionInq: false,
      isShowItemCurrentInventoryInq: false,
      isShowFabricPurchaseHistoryInq: false,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  moduleCaption = "InBound Receipt Maintenance";
  fetchAttributesFromLocalStorage = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    let warehouses = attribute_cache.warehouses;
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        this.state.wareHouses.push(attr);
      });
    }
    this.state.unapprovalReasons = [];
    let unapprovalReasons = attribute_cache.purchaseOrderUnApprovalReasons;
    if (!isEmptyArray(unapprovalReasons))
      unapprovalReasons.map((ent) => {
        this.state.unapprovalReasons.push(ent);
      });
    this.state.cancelReasons = [];
    let cancelReasons = attribute_cache.purchaseOrderCancelReasons;
    if (!isEmptyArray(cancelReasons))
      cancelReasons.map((ent) => {
        this.state.cancelReasons.push(ent);
      });
    this.state.services = [];
    let services = attribute_cache.serviceInfos;
    if (!isEmptyArray(services))
      services.map((ent) => {
        this.state.services.push(ent);
      });
  };
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.setState({
        is3PL: true,
      });
    }
    const { cache } = appData;
    this.cache = cache;
    ModuleUtils.getLogisticOrderReceiptStatusList();
    ModuleUtils.getLogisticOrderReceiptLineStatusList();
    ModuleUtils.getInvoiceStatusList();
    this.fetchAttributesFromLocalStorage();
    let isSpecialViewMode = this.state.isSpecialViewMode;
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      this.state.isSpecialViewMode = isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isSpecialViewMode: isSpecialViewMode,
      isReadOnlyOrDisabled: isReadOnly,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      this.editLogisticReceipt(this.props.code);

      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isViewMode: false,
      });
    } else {
      this.addNewEntry();
    }
    this.initLookupHandlers();
    // this.loadLogisticReceiptPage();
  }
  initLookupHandlers = () => {
    //
    let logisticReceiptLookupHandler = new LogisticReceiptLookupHandler(
      this.companyCode,
      "Receipt"
    );
    this.setState({
      logisticReceiptLookupHandler: logisticReceiptLookupHandler,
    });

    let serviceLookupHandler = new GenericAttributeLookupHandler(
      this.state.services,
      "Service"
    );
    this.setState({ serviceLookupHandler: serviceLookupHandler });
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = new Array();
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  setOrderLinesToReceiptLines = (orderLines) => {
    let lines = new Array();
    if (!isEmptyArray(orderLines)) {
      orderLines.map((ln) => {
        const receiptLineData = new LogisticOrderReceiptLineBean();
        receiptLineData.lineNumber = ln.lineNumber;
        receiptLineData.logisticOrderNumber = ln.logisticOrderNumber;
        receiptLineData.logisticOrderLineNumber = ln.lineNumber;
        receiptLineData.fabricStyleCode = ln.fabricStyleCode;
        receiptLineData.fabricStyleName = ln.fabricStyleName;
        // receiptLineData.lineStatus = ln.lineStatus;
        receiptLineData.lineStatus =
          LogicConstants.LOGISTIC_ORDER_RECEIPT_LINE_OPEN_STATUS;
        receiptLineData.widthCode = ln.widthCode;
        receiptLineData.colorCode = ln.colorCode;
        receiptLineData.skuNumber = ln.skuNumber;
        receiptLineData.upcCode = ln.upcCode;
        receiptLineData.uomCode = ln.uomCode;
        receiptLineData.companyCode = ln.companyCode;
        let openQuantity =
          ln.orderQuantity + ln.adjustedQuantity - ln.receivedQuantity;
        if (openQuantity < 0) openQuantity = 0;
        receiptLineData.openOrderQuantity = openQuantity;
        let orderQuantity = ln.orderQuantity + ln.adjustedQuantity;
        receiptLineData.logisticOrderQuantity = orderQuantity;
        receiptLineData.receivedQuantity = ln.receivedQuantity;
        let receivedQuantityToDate =
          ln.receivedQuantity + ln.receivedAdjustedQuantity;
        receiptLineData.receivedQuantityToDate = receivedQuantityToDate;
        receiptLineData.locationCode = ln.locationCode;
        receiptLineData.inventoryUomCode = ln.inventoryUomCode;
        receiptLineData.uomConversionRate = ln.uomConversionRate;

        lines.push(receiptLineData);
      });
    }
    return lines;
  };
  readOrderResponse = (response) => {
    if (response.data.logisticOrder != null) {
      const logisticOrderData = response.data.logisticOrder;
      if (
        logisticOrderData.orderStatus ===
          LogicConstants.LOGISTIC_ORDER_APPROVE_STATUS ||
        logisticOrderData.orderStatus ===
          LogicConstants.LOGISTIC_ORDER_PARTIALLY_RECEIVED_STATUS
      ) {
        const logisticReceiptData = this.state.logisticReceiptData;
        logisticReceiptData.logisticOrderNumber = logisticOrderData.code;
        logisticReceiptData.customerCode = logisticOrderData.customerCode;
        logisticReceiptData.customerName = logisticOrderData.customerName;
        logisticReceiptData.locationCode = logisticOrderData.locationCode;
        logisticReceiptData.containerNumber = logisticOrderData.containerNumber;
        logisticReceiptData.customerReferenceNumber =
          logisticOrderData.customerReferenceNumber;
        logisticReceiptData.warehousePurchaseOrderNumber =
          logisticOrderData.warehousePurchaseOrderNumber;
        logisticReceiptData.projectNumber = logisticOrderData.projectNumber;
        logisticReceiptData.lines = new Array();
        const lines = this.setOrderLinesToReceiptLines(logisticOrderData.lines);
        logisticReceiptData.lines = lines;

        this.setState({
          logisticReceiptData: logisticReceiptData,
          isLoading: false,
          loadingText: "",
        });
      }
    }
    this.setState({
      isLoading: false,
      loadingText: "",
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readLogisticOrder = (code) => {
    const readrequest = new RestReadRequest();
    readrequest.code = code;
    readrequest.companyCode = this.companyCode;
    LogisticOrderService.readLogisticOrder(
      readrequest,
      this.readOrderResponse,
      this.errorCallBack
    );
    this.setState({
      isLoading: true,
    });
  };
  setvalues = (code) => {
    this.readLogisticOrder(code);
  };

  onLogisticOrderChange = (e) => {
    let logisticOrderNumber = e.target.value;
    this.state.isShowAutoCompleteLogisticOrderList = true;
    let receiptData = this.state.logisticReceiptData;
    let showAutoCompleteList = this.state.isShowAutoCompleteLogisticOrderList;
    if (isEmpty(logisticOrderNumber)) {
      this.state.isShowAutoCompleteLogisticOrderList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLogisticOrderList;
      const logisticReceiptData = this.state.logisticReceiptData;
      logisticReceiptData.customerCode = "";
      logisticReceiptData.customerName = "";
      logisticReceiptData.locationCode = "";
      logisticReceiptData.lines = new Array();
      let suggestion = [];
      this.setState({
        isShowAutoCompleteLogisticOrderList: showAutoCompleteList,
        logisticReceiptData: logisticReceiptData,
        logisticOrderPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "logisticOrderNumber" &&
      showAutoCompleteList === true &&
      logisticOrderNumber !== ""
    ) {
      this.readLogisticOrderBySearchString(e.target.value);
    }
    receiptData[e.target.name] = e.target.value;
    this.setState({ logisticReceiptData: receiptData });
  };
  readLogisticOrderBySearchString(searchString) {
    let searchCriteria = new LogisticOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.logisticOrderNumberStartsWith = searchString;
    searchCriteria.logisticOrderNumberContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let requestInput = new RestLogisticOrderListRequest();
    requestInput.pageInput = pageList;
    requestInput.criteria = searchCriteria;
    LogisticOrderService.getLogisticOrderPageList(
      requestInput,
      this.readLogisticOrderBySearchStringResponse,
      this.errorCallBack
    );
  }
  readLogisticOrderBySearchStringResponse = (response) => {
    let logisticOrder_list = new Array();
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.logisticOrderPageList) &&
      !isEmptyArray(response.data.logisticOrderPageList.logisticOrders)
    ) {
      logisticOrder_list = response.data.logisticOrderPageList.logisticOrders;
      let simpleAutoCompleteList = new Array();

      if (logisticOrder_list.length > 0 && logisticOrder_list != null) {
        logisticOrder_list.map((po) => {
          if (
            po.orderStatus == LogicConstants.LOGISTIC_ORDER_APPROVE_STATUS ||
            po.orderStatus ==
              LogicConstants.LOGISTIC_ORDER_PARTIALLY_RECEIVED_STATUS
          ) {
            let simpleItemBean = {
              code: po.code,
              description: "",
            };
            simpleAutoCompleteList.push(simpleItemBean);
          }
        });
      }
      this.setState({
        logisticOrderPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };

  logisticOrderEnterKeyEventHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading InBound Order...",
    });
    this.setvalues(e.target.value);
    this.setState({
      logisticOrderPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLogisticOrderList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteLogisticOrderList: showAutoCompleteList,
    });
  };
  getListResponse = (response) => {
    let logisticReceipt_list = new Array();
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.logisticOrderReceiptPageList) &&
      !isEmptyArray(
        response.data.logisticOrderReceiptPageList.logisticOrderReceipts
      )
    ) {
      logisticReceipt_list =
        response.data.logisticOrderReceiptPageList.logisticOrderReceipts;
      this.state.pageList.totalCount =
        response.data.logisticOrderReceiptPageList.totalCount;
      this.state.pageList.currentPage =
        response.data.logisticOrderReceiptPageList.currentPage;
    }
    this.setState({
      logisticReceipt_list: logisticReceipt_list,
      isLoading: false,
      loadingText: "",
    });
  };
  loadLogisticReceiptPage = () => {
    let request = new RestLogisticOrderReceiptListRequest();
    const criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    request.criteria = criteria;
    request.pageInput = this.state.pageList;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.LogesticReceipt_IsAccessible()) {
      LogisticOrderReceiptService.getLogisticOrderReceiptPageList(
        request,
        this.getListResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isLoading: true,
    });
  };
  addNewEntry = () => {
    let logisticReceiptData = new LogisticOrderReceiptBean();
    logisticReceiptData.companyCode = this.companyCode;
    logisticReceiptData.code = NEW_ENTRY;
    logisticReceiptData.locationCode = DEFAULT_WAREHOUSE;
    let pageTitle = this.moduleCaption + " - NEW";
    logisticReceiptData.receiptStatus =
      LogicConstants.LOGISTIC_ORDER_RECEIPT_UNAPPROVE_STATUS;
    logisticReceiptData.createdDate = toFormattedDate_v1(new Date());
    logisticReceiptData.receiptDate = toFormattedDate_v1(new Date());
    if (!isEmptyString(this.state.moduleKeyCode)) {
      logisticReceiptData.code = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        this.isLocked = false;
      } else {
        this.isLocked = true;
      }
    }

    this.setState({
      logisticReceiptData: logisticReceiptData,
      pageTitle: pageTitle,
      isLoading: false,
      loadingText: "",
      selectedNodeKey: "headerView",
    });
    this.state.logisticReceiptData = logisticReceiptData;
    this.openEntryForm();
  };
  openEntryForm = () => {
    //
    this.closeAllNodeViews();
    this.getNodeList();
    this.setState({
      isLogisticReceiptEntryFormOpen: true,
      isLogisticReceiptListFormOpen: false,
      isShowSaveButton: true,
      isShowClearErrorButton: true,
      isShowNodes: true,
      isShowModuleSearchContainer: true,
      isResetView: false,
      isShowPDFReportButton: false,
      isShowExcelButton: false,
      isLogisticReceiptHistoryFormOpen: false,
      isLogisticReceiptInvoiceFormOpen: false,
      isDisabledFields: false,
      isLogisticReceiptImageFormOpen: false,
      isLogisticReceiptDocumentFormOpen: false,
    });

    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isLogisticReceiptListFormOpen: false,
        disabled: false,
        isDisabledFields: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.moduleCaption + " - VIEW";
        this.setState({
          isDisabledFields: true,
          // isDisableNodeFields: true,
          disabled: true,
          pageTitle: pageTitle,
        });
      }
    } else {
      this.setState({
        disabled: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let receiptStatus = ModuleUtils.getLogisticOrderReceiptStatusCaption(
      this.state.logisticReceiptData.receiptStatus
    );
    if (receiptStatus !== undefined && receiptStatus !== null) {
      moduleOrderStatus = receiptStatus;
    }
    this.setState({ moduleOrderStatus: moduleOrderStatus });
    this.initModuleButtons();
  };

  initModuleButtons = () => {
    const logisticReceiptData = this.state.logisticReceiptData;
    if (
      logisticReceiptData.receiptStatus ==
      LogicConstants.LOGISTIC_ORDER_RECEIPT_UNAPPROVE_STATUS
    ) {
      if (logisticReceiptData.isFetched) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: false,
          isShowApproveButton: true,
          isShowSaveButton: true,
          isShowCreateInvoiceButton: false,
          isShowPDFReportButton: true,
          isShowExcelButton: true,
          disableUpdatableFields: false,
        });
      } else {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: false,
          isShowApproveButton: false,
          isShowSaveButton: true,
          isShowCreateInvoiceButton: false,
          isShowPDFReportButton: false,
          isShowExcelButton: false,
          isDisabledFields: false,
          disableUpdatableFields: false,
        });
      }
    }
    if (
      logisticReceiptData.receiptStatus ==
      LogicConstants.LOGISTIC_ORDER_RECEIPT_APPROVE_STATUS
    ) {
      this.setState({
        // isShowUnApproveButton: true,
        isShowCancelButton: true,
        isShowApproveButton: false,
        isShowSaveButton: true,
        // isShowCreateInvoiceButton: true,
        isShowPDFReportButton: true,
        isShowExcelButton: true,
        isDisabledFields: true,
        disableUpdatableFields: false,
      });
      if (this.state.isShowBasedonInvoices) {
        this.setState({
          isShowCreateInvoiceButton: false,
        });
      } else {
        this.setState({
          isShowCreateInvoiceButton: true,
        });
      }
    }
    if (
      logisticReceiptData.receiptStatus ==
      LogicConstants.LOGISTIC_ORDER_RECEIPT_CANCEL_STATUS
    ) {
      this.setState({
        isShowUnApproveButton: false,
        isShowCancelButton: false,
        isShowApproveButton: false,
        isShowSaveButton: false,
        isShowCreateInvoiceButton: false,
        isShowPDFReportButton: false,
        isShowExcelButton: true,
        isDisabledFields: true,
        disableUpdatableFields: true,
      });
    }
  };
  closeEntryForm = () => {
    this.clearError();
    this.closeAllNodeViews();
    let pageTitle = this.moduleCaption;
    this.setState({
      isLogisticReceiptEntryFormOpen: false,
      isLogisticReceiptListFormOpen: true,
      isShowSaveButton: false,
      isShowPDFReportButton: false,
      isShowExcelButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isResetView: false,
      isMaintenanceMode: false,
      isLogisticReceiptHistoryFormOpen: false,
      isLogisticReceiptInvoiceFormOpen: false,
      isViewMode: false,
      isSpecialViewMode: false,
      isDisabledFields: false,
      isShowBasedonInvoices: false,
      isShowItemImagePopup: false,
      mainImageUrl: "",
      webImageUrl: "",
      frontImageUrl: "",
      backImageUrl: "",
      mainImgData: null,
      webImgData: null,
      frontImgData: null,
      BackImgData: null,

      isShowItemDocPopup: false,
      doc1Url: "",
      doc2Url: "",
      doc3Url: "",
      doc4Url: "",
      doc1Name: "",
      doc2Name: "",
      doc3Name: "",
      doc4Name: "",
      doc1Data: null,
      doc2Data: null,
      doc3Data: null,
      doc4Data: null,
      isLogisticReceiptImageFormOpen: false,
      isLogisticReceiptDocumentFormOpen: false,
    });
  };

  showToast = (msg, type, lvl) => {
    let errList = [];
    if (type === 1) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "success",
        // isShowAlertLvl1: true,
      });
    } else if (type === 2) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        // isShowAlertLvl1: true,
      });
    }
    if (lvl == 1) {
      this.setState({
        isShowAlertLvl1: true,
      });
    } else if (lvl == 5) {
      this.setState({
        isShowAlertLvl5: true,
      });
    }
  };

  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let headerObject = this.getEmptyView();
    let headerNode = new NodeData("headerView", "Header", headerObject);
    let historyNode = new NodeData("historyView", "History", headerObject);
    let invoiceNode = new NodeData("invoiceView", "Invoices", headerObject);
    let imageNode = new NodeData("imageView", "Image", headerObject);
    let documentNode = new NodeData("documentView", "Document", headerObject);
    let logisticReceiptData = this.state.logisticReceiptData;
    nodeList["headerView"] = headerNode;
    if (logisticReceiptData.isFetched) {
      nodeList["historyView"] = historyNode;
      nodeList["invoiceView"] = invoiceNode;
      nodeList["imageView"] = imageNode;
      nodeList["documentView"] = documentNode;
    }
    this.setState({ nodeList: nodeList });
  };

  nodeOnSelect = (selectedNode) => {
    if (selectedNode == "headerView") {
      this.setLogisticReceiptHeaderView();
    } else if (selectedNode == "historyView") {
      this.setLogisticReceiptHistoryView();
    } else if (selectedNode == "invoiceView") {
      this.setLogisticReceiptInvoiceView();
    } else if (selectedNode == "imageView") {
      this.setLogisticReceiptImageView();
    } else if (selectedNode == "documentView") {
      this.setLogisticReceiptDocumentView();
    }
    this.setState({ selectedNodeKey: selectedNode });
  };
  closeLogisticModalCallBack = (isOpen) => {
    this.setState({ isShowLogisticOrderModule: isOpen, moduleForPopup: [] });
  };
  onPopupModalExit = () => {
    this.closeLogisticModalCallBack(false);
  };
  lnkLogisticOrderModule = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowLogisticOrderModule: true,
          moduleForPopup: (
            <PopupLogisticOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  setLogisticReceiptImageView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isLogisticReceiptEntryFormOpen: false,
      isLogisticReceiptListFormOpen: false,
      isLogisticReceiptHistoryFormOpen: false,
      isLogisticReceiptInvoiceFormOpen: false,
      isLogisticReceiptImageFormOpen: true,
      isLogisticReceiptDocumentFormOpen: false,
    });
  };
  setLogisticReceiptDocumentView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isLogisticReceiptEntryFormOpen: false,
      isLogisticReceiptListFormOpen: false,
      isLogisticReceiptHistoryFormOpen: false,
      isLogisticReceiptInvoiceFormOpen: false,
      isLogisticReceiptImageFormOpen: false,
      isLogisticReceiptDocumentFormOpen: true,
    });
  };
  setLogisticReceiptHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isLogisticReceiptEntryFormOpen: true,
      isLogisticReceiptListFormOpen: false,
      isLogisticReceiptHistoryFormOpen: false,
      isLogisticReceiptInvoiceFormOpen: false,
      isLogisticReceiptImageFormOpen: false,
      isLogisticReceiptDocumentFormOpen: false,
    });
  };
  setLogisticReceiptHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isLogisticOrderEntryFormOpen: false,
      isLogisticOrderListFormOpen: false,
      isLogisticReceiptHistoryFormOpen: true,
      isLogisticReceiptInvoiceFormOpen: false,
      isLogisticReceiptImageFormOpen: false,
      isLogisticReceiptDocumentFormOpen: false,
    });
  };
  setLogisticReceiptInvoiceView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isLogisticOrderEntryFormOpen: false,
      isLogisticOrderListFormOpen: false,
      isLogisticReceiptHistoryFormOpen: false,
      isLogisticReceiptInvoiceFormOpen: true,
      isLogisticReceiptImageFormOpen: false,
      isLogisticReceiptDocumentFormOpen: false,
    });
  };
  closeAllNodeViews = () => {
    this.setState({
      isLogisticReceiptEntryFormOpen: false,
      isLogisticReceiptListFormOpen: false,
      isLogisticReceiptHistoryFormOpen: false,
      isLogisticReceiptInvoiceFormOpen: false,
      isLogisticReceiptImageFormOpen: false,
      isLogisticReceiptDocumentFormOpen: false,
    });
  };
  readReceiptResponse = (response) => {
    let errMsg = "";
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.logisticOrderReceiptResponse != null) {
      if (response.data.logisticOrderReceiptResponse.errors != null) {
        response.data.logisticOrderReceiptResponse.errors.map((err) => {
          errMsg = err.messageDescription;
        });
      }
    }
    if (
      errMsg !=
      "Logistic Order Receipt [" + this.state.moduleKeyCode + "] Not read!"
    ) {
      this.showErrorMessage(response.data.logisticOrderReceiptResponse);
    }
    if (response.data.isSuccess == true) {
      this.setState({ isLoading: false, loadingText: "" });

      let dependenciesBean = new LogisticOrderReceiptModuleDependenciesBean();
      if (
        response.data.dependenciesResponse != null &&
        response.data.dependenciesResponse.dependenciesBean != null
      ) {
        dependenciesBean = response.data.dependenciesResponse.dependenciesBean;
        if (!isEmptyArray(dependenciesBean.invoices)) {
          const invoices = [...dependenciesBean.invoices];
          this.setState({
            invList: invoices,
          });
          const result = invoices.filter(
            (inv) => inv.invoiceStatus != LogicConstants.INVOICE_CANCEL_STATUS
          );
          if (!isEmptyArray(result)) {
            this.setState({
              isShowBasedonInvoices: true,
            });
          }
        }
      }
      if (
        response.data.logisticOrderReceiptResponse != null &&
        response.data.logisticOrderReceiptResponse.logisticOrderReceipt != null
      ) {
        const logisticReceiptData =
          response.data.logisticOrderReceiptResponse.logisticOrderReceipt;
        let pageTitle = this.moduleCaption + " - VIEW";
        let moduleKeyCode = logisticReceiptData.code;
        this.clearError();

        // if (
        //   !isEmptyArray(
        //     response.data.logisticOrderReceiptResponse.logisticOrderReceipt
        //       .receiptImages
        //   )
        // ) {
        //   const itemImage__List =
        //     response.data.logisticOrderReceiptResponse.logisticOrderReceipt
        //       .receiptImages;
        //   itemImage__List.map((img) => {
        //     if (img.imagePart === MAIN_IMAGE_PART) {
        //       let url = this.getImageURL();
        //       url = url + img.imageName;

        //       this.setMainUrl(url);
        //     }
        //     if (img.imagePart === WEB_IMAGE_PART) {
        //       let url = this.getImageURL();
        //       url = url + img.imageName;
        //       this.setWebUrl(url);
        //     }
        //     if (img.imagePart === FRONT_IMAGE_PART) {
        //       let url = this.getImageURL();
        //       url = url + img.imageName;
        //       this.setFrontUrl(url);
        //     }
        //     if (img.imagePart === BACK_IMAGE_PART) {
        //       let url = this.getImageURL();
        //       url = url + img.imageName;
        //       this.setBackUrl(url);
        //     }
        //   });
        //   this.setState({
        //     mainImgData: null,
        //     webImgData: null,
        //     frontImgData: null,
        //     BackImgData: null,
        //   });
        // } else {
        //   this.setState({
        //     mainImageUrl: "",
        //     webImageUrl: "",
        //     frontImageUrl: "",
        //     backImageUrl: "",
        //     mainImgData: null,
        //     webImgData: null,
        //     frontImgData: null,
        //     BackImgData: null,
        //   });
        // }

        // if (
        //   !isEmptyArray(
        //     response.data.logisticOrderReceiptResponse.logisticOrderReceipt
        //       .logisticOrderReceiptDocuments
        //   )
        // ) {
        //   const itemDocuments__List =
        //     response.data.logisticOrderReceiptResponse.logisticOrderReceipt
        //       .logisticOrderReceiptDocuments;
        //   this.setState({
        //     doc1Url: "",
        //     doc2Url: "",
        //     doc3Url: "",
        //     doc4Url: "",
        //     doc1Data: null,
        //     doc2Data: null,
        //     doc3Data: null,
        //     doc4Data: null,
        //     doc1Name: "",
        //     doc2Name: "",
        //     doc3Name: "",
        //     doc4Name: "",
        //   });
        //   itemDocuments__List.map((doc) => {
        //     if (doc.documentNumber == 1) {
        //       let url = this.getDocURL();
        //       url = url + doc.documentName;
        //       this.setDoc1Url(url);
        //       this.setDoc1Name(doc.documentName);
        //       // this.setDoc1Data(doc);
        //     } else if (doc.documentNumber == 2) {
        //       let url = this.getDocURL();
        //       url = url + doc.documentName;
        //       this.setDoc2Url(url);
        //       this.setDoc2Name(doc.documentName);
        //       // this.setDoc2Data(doc);
        //     } else if (doc.documentNumber == 3) {
        //       let url = this.getDocURL();
        //       url = url + doc.documentName;
        //       this.setDoc3Url(url);
        //       this.setDoc3Name(doc.documentName);
        //       // this.setDoc3Data(doc);
        //     } else if (doc.documentNumber == 4) {
        //       let url = this.getDocURL();
        //       url = url + doc.documentName;
        //       this.setDoc4Url(url);
        //       this.setDoc4Name(doc.documentName);
        //       // this.setDoc4Data(doc);
        //     }
        //   });
        //   this.setState({
        //     doc1Data: null,
        //     doc2Data: null,
        //     doc3Data: null,
        //     doc4Data: null,
        //   });
        // } else {
        //   this.setState({
        //     doc1Url: "",
        //     doc2Url: "",
        //     doc3Url: "",
        //     doc4Url: "",
        //     doc1Data: null,
        //     doc2Data: null,
        //     doc3Data: null,
        //     doc4Data: null,
        //     doc1Name: "",
        //     doc2Name: "",
        //     doc3Name: "",
        //     doc4Name: "",
        //   });
        // }

        if (!isEmptyArray(logisticReceiptData.logisticOrderReceiptDocuments)) {
          const preview_Docs =
            logisticReceiptData.logisticOrderReceiptDocuments;
          let url = this.getDocURL();
          let urlDoc_list = [];
          preview_Docs.map((urlIndex) => {
            urlDoc_list.push(url + urlIndex.documentName);
          });
          this.setState({
            documents: preview_Docs,
            preview_Docs: urlDoc_list,
          });
        } else {
          this.setState({
            preview_Docs: [],
            documents: [],
          });
        }
        if (!isEmptyArray(logisticReceiptData.receiptImages)) {
          const imagesList = logisticReceiptData.receiptImages;

          let url = this.getImageURL();
          let url_list = [];
          imagesList.map((urlIndex) => {
            url_list.push(url + urlIndex.imageName);
          });
          this.setState({
            imgData: null,
            preview_Url: url_list,
            images: imagesList,
          });
        } else {
          this.setState({
            imgUrl: "",
            imgData: null,
            images: [],
            preview_Url: [],
          });
        }

        this.state.logisticReceiptData = logisticReceiptData;

        this.setState({
          logisticReceiptData: logisticReceiptData,
          pageTitle: pageTitle,
          isShowNodes: true,
          moduleKeyCode: moduleKeyCode,
          isLoading: false,
          loadingText: "",
          selectedNodeKey: "headerView",
          dependenciesBean: dependenciesBean,
        });
        this.isLocked = true;
        this.getNodeList();
        this.openEntryForm();
      } else {
        this.addNewEntry();
      }
    }
  };
  editLogisticReceipt = (code) => {
    const readrequest = new RestReadRequest();
    readrequest.code = code;
    readrequest.companyCode = this.companyCode;
    // readrequest.isLoadChildren = true;
    // let isLockRequired = NEW_ENTRY === code ? false : true;
    // readrequest.isLockRequired = isLockRequired;

    if (!this.state.isSpecialViewMode) {
      let isLockRequired = NEW_ENTRY === code ? false : true;
      readrequest.isLockRequired = isLockRequired;
    } else {
      readrequest.isLockRequired = false;
    }

    if (SecurityAccessManager.LogisticOrderReceiptView_IsAccessible()) {
      LogisticOrderReceiptService.initLogisticOrderReceiptModule(
        readrequest,
        this.readReceiptResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isLoading: true,
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  unlockResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editLogisticReceipt(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        if (!this.state.isReseted) {
          this.showErrorMessage(response.data);
        }
      }
    }
  };
  unLockLogisticReceipt = (code) => {
    const request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.LogesticReceipt_IsAccessible()) {
      LogisticOrderReceiptService.unLockLogisticOrderReceiptNumber(
        request,
        this.unlockResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  moduleExit = () => {
    let logisticReceiptData = this.state.logisticReceiptData;
    if (logisticReceiptData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unLockLogisticReceipt(logisticReceiptData.code);
      } else {
        this.isLocked = false;
      }

      this.props.onModuleExit();
    }
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  resetView = () => {
    let logistic_ReceiptData = this.state.logisticReceiptData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode)
        this.unLockLogisticReceipt(logistic_ReceiptData.code);
    } else {
      this.isLocked = false;
    }

    let logisticReceiptData = new LogisticOrderReceiptBean();

    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.setState({
      isShowAlert: false,
      isResetModule: true,
      disabled: false,
      selectedNodeKey: "headerView",
      logisticReceiptData: logisticReceiptData,
      isShowBasedonInvoices: false,
      isShowItemImagePopup: false,
      mainImageUrl: "",
      webImageUrl: "",
      frontImageUrl: "",
      backImageUrl: "",
      mainImgData: null,
      webImgData: null,
      frontImgData: null,
      BackImgData: null,

      isShowItemDocPopup: false,
      doc1Url: "",
      doc2Url: "",
      doc3Url: "",
      doc4Url: "",
      doc1Name: "",
      doc2Name: "",
      doc3Name: "",
      doc4Name: "",
      doc1Data: null,
      doc2Data: null,
      doc3Data: null,
      doc4Data: null,
    });
    this.hideAlertCallBack();
    this.clearError();
    this.addNewEntry();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };

  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  selectButtonClick = (e) => {
    if (!this.isLocked) {
      this.editLogisticReceipt(this.state.moduleKeyCode);
    }

    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  getModuleListView = () => {
    let logisticReceiptData = this.state.logisticReceiptData;
    if (logisticReceiptData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadPage(1);
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unLockLogisticReceipt(logisticReceiptData.code);
      } else {
        this.isLocked = false;
      }

      this.closeEntryForm();
      this.loadPage(1);
    }
  };
  handleKeyDown = () => {
    this.editLogisticReceipt(this.state.moduleKeyCode);
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadLogisticReceiptPage();
  };
  criteriaOnChange = (e) => {
    const criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;

    this.setState({ criteria: criteria });
  };
  filterLogisticReceipt = () => {
    this.loadPage(1);
  };
  resetLogisticReceipt = () => {
    let criteria = new LogisticOrderReceiptSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });

    this.loadPage(1);
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let logisticReceipt_list = this.state.logisticReceipt_list;
    if (sortField && !isEmptyArray(logisticReceipt_list)) {
      const sorted = [...logisticReceipt_list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ logisticReceipt_list: sorted });
    }
  };
  downloadReportResponse = (response) => {
    this.setState({
      isLoading: false,
    });
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
  };
  generatePDF = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating PDF",
    });
    this.downloadReport(1, this.state.logisticReceiptData.code);
  };
  generateExcel = (e) => {
    if (e.detail === 1) {
      this.setState({
        isLoading: true,
        loadingText: "Generating Excel",
      });
      this.downloadReport(2, this.state.logisticReceiptData.code);
    }
  };
  downloadReport = (reportType, code) => {
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let requestInput = new RestEntityPrintRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.entityCode = code;
    requestInput.reportBean = reportBean;
    if (reportBean.reportType == 1) {
      if (SecurityAccessManager.LogisticOrderReceiptPDFReport_IsAccessible()) {
        ReportService.generateLogisticOrderReceiptPrintReport(
          requestInput,
          this.downloadReportResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.LogisticOrderReceiptExcelReport_IsAccessible()
      ) {
        ReportService.generateLogisticOrderReceiptPrintReport(
          requestInput,
          this.downloadReportResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  saveResponse = (response) => {
    this.handleResponse(response.data);
    if (
      !isEmpty(response) &&
      !isEmpty(response.data) &&
      !isEmpty(response.data.logisticOrderReceipt)
    ) {
      const logisticReceiptData = response.data.logisticOrderReceipt;
      if (response.data.success == true) {
        this.state.logisticReceiptData = logisticReceiptData;
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          isLoading: false,
          logisticReceiptData: logisticReceiptData,
          loadingText: "",
          pageTitle: pageTitle,
        });

        this.uploadImagesToServer();
        this.uploadMultiDocsToServer();

        if (!this.isLocked) {
          this.editLogisticReceipt(response.data.logisticOrderReceipt.code);
        } else {
          this.code = logisticReceiptData.code;
          this.unLockLogisticReceipt(response.data.logisticOrderReceipt.code);
        }
      }
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  // saveLogisticReceipt = (logisticReceiptData) => {
  //   this.setState({ isLoading: true, loadingText: "Saving .." });
  //   if (!logisticReceiptData.isFetched) {
  //     if (SecurityAccessManager.LogisticOrderReceiptCreation_IsAccessible()) {
  //       LogisticOrderReceiptService.createLogisticOrderReceipt(
  //         logisticReceiptData,
  //         this.saveResponse,
  //         this.errorCallBack
  //       );
  //     } else {
  //       let errMsg = "Access Denied";
  //       let errList = [];
  //       errList.push(errMsg);
  //       this.setState({
  //         alertMessage: errList,
  //         alertType: "danger",
  //         isShowAlert: true,
  //       });
  //     }
  //   } else {
  //     if (SecurityAccessManager.LogisticOrderReceiptUpdation_IsAccessible()) {
  //       LogisticOrderReceiptService.updateLogisticOrderReceipt(
  //         logisticReceiptData,
  //         this.saveResponse,
  //         this.errorCallBack
  //       );
  //     } else {
  //       let errMsg = "Access Denied";
  //       let errList = [];
  //       errList.push(errMsg);

  //       this.setState({
  //         alertMessage: errList,
  //         alertType: "danger",
  //         isShowAlert: true,
  //       });
  //     }
  //   }
  // };
  saveLogisticReceipt = (logisticReceiptData) => {
    this.setState({ isLoading: true, loadingText: "Saving .." });
    if (logisticReceiptData.isFetched) {
      if (
        logisticReceiptData.receiptStatus ==
        LogicConstants.LOGISTIC_ORDER_RECEIPT_UNAPPROVE_STATUS
      ) {
        if (SecurityAccessManager.LogisticOrderReceiptUpdation_IsAccessible()) {
          LogisticOrderReceiptService.updateLogisticOrderReceipt(
            logisticReceiptData,
            this.saveResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else if (
        logisticReceiptData.receiptStatus ==
          LogicConstants.LOGISTIC_ORDER_RECEIPT_APPROVE_STATUS ||
        logisticReceiptData.receiptStatus ==
          LogicConstants.LOGISTIC_ORDER_RECEIPT_APPROVE_STATUS
      ) {
        if (SecurityAccessManager.LogisticOrderReceiptCreation_IsAccessible()) {
          LogisticOrderReceiptService.updateLogisticOrderReceiptAfterApproval(
            logisticReceiptData,
            this.saveResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    } else {
      if (SecurityAccessManager.LogisticOrderReceiptCreation_IsAccessible()) {
        LogisticOrderReceiptService.createLogisticOrderReceipt(
          logisticReceiptData,
          this.saveResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  save = () => {
    const logisticReceiptData = this.state.logisticReceiptData;
    this.saveLogisticReceipt(logisticReceiptData);
  };
  /******** header lookup */

  onLocationChange = (e) => {
    let locationCode = e.target.value;
    this.state.isShowAutoCompleteLocationList = true;
    let tempData = this.state.logisticReceiptData;
    let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.isShowAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
      let tempData = this.state.logisticReceiptData;
      tempData.locationCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteLocationList: showAutoCompleteList,
        logisticReceiptData: tempData,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "locationCode" &&
      showAutoCompleteList === true &&
      locationCode !== ""
    ) {
      this.readLocationBySearchString(e.target.value);
      this.readLocation(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ logisticReceiptData: tempData });
  };
  locationEnterKeyEventHandler = (e) => {
    this.readLocation(e.target.value);
    this.state.isShowAutoCompleteLocationList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoCompleteLocationList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteLocationList: isShowAutoCompleteList,
    });
  };
  readLocationBySearchString = (searchString) => {
    let locationData = this.state.wareHouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((obj) => {
        let locationBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      locationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readLocation = (locationCode) => {
    let tempData = this.state.logisticReceiptData;
    let locationBean = null;
    let locationData = null;
    this.state.wareHouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      tempData.locationCode = locationBean.code;
      this.state.isShowAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
      this.setState({
        logisticReceiptData: tempData,
        isShowAutoCompleteLocationList: showAutoCompleteList,
      });
    }
  };
  onChange = (e) => {
    let logisticReceiptData = this.state.logisticReceiptData;
    logisticReceiptData[e.target.name] = e.target.value;
    this.setState({ logisticReceiptData: logisticReceiptData });
  };
  getLogisticReceiptLine = (e, rowData) => {
    if (e.detail == 1) {
      let logisticReceiptLineData = { ...rowData };
      let receiptRollLines = [...this.state.receiptRollLines];
      if (!isEmptyArray(rowData.receiptRollLines))
        receiptRollLines.push(...rowData.receiptRollLines);
      logisticReceiptLineData.totalRolls = receiptRollLines.length;
      let logisticReceiptRollLineBeanFilter =
        new LogisticOrderReceiptRollLineBeanFilter();
      let tempArray = [];
      this.setState({
        logisticReceiptLineData: logisticReceiptLineData,
        receiptRollLines: receiptRollLines,
        isShowLinePopup: true,
        logisticReceiptRollLineBeanFilter: logisticReceiptRollLineBeanFilter,
        filterLogisticReceiptList: tempArray,
        isSearchCriteria: false,
        isResetCriteria: true,
        isShowFilterList: false,
      });
    }
  };

  closeAlertModalCallBackLvl1 = (isShowPopup) => {
    this.setState({
      isShowLinePopup: isShowPopup,
      isShowAlertLvl1: isShowPopup,
      isShowItemImagePopup: false,
    });
    this.hideAlertCallBackLvl1();
    this.clearLineData();
  };
  hideAlertCallBackLvl1 = (msgType, isDisplayed) => {
    this.setState({
      isShowAlertLvl1: false,
    });
  };
  closeAlertModalCallBackLvl5 = (isShowPopup) => {
    this.setState({
      isShowRollLinePopup: isShowPopup,
      isShowAlertLvl5: isShowPopup,
      logisticReceiptRollLineData: new LogisticOrderReceiptRollLineBean(),
      isShowItemDocPopup: false,
    });
    this.hideAlertCallBackLvl5();
    // this.clearRollLineData(false);
  };

  hideAlertCallBackLvl5 = (msgType, isDisplayed) => {
    this.setState({
      isShowAlertLvl5: false,
    });
  };

  setDefaultValue = () => {
    const logisticReceiptLineData = { ...this.state.logisticReceiptLineData };
    const logisticReceiptData = { ...this.state.logisticReceiptData };
    const logisticReceiptRollLineData = new LogisticOrderReceiptRollLineBean();
    // const logisticReceiptRollLineData = {
    //   ...this.state.logisticReceiptRollLineData,
    // };
    const receiptRollLines = [...this.state.receiptRollLines];
    let lineNumber = this.getMaxRollLineNumber(receiptRollLines);
    logisticReceiptRollLineData.companyCode =
      logisticReceiptLineData.companyCode;
    logisticReceiptRollLineData.logisticRollLineNumber = ++lineNumber;
    logisticReceiptRollLineData.logisticOrderReceiptNumber =
      logisticReceiptLineData.logisticOrderReceiptNumber;
    logisticReceiptRollLineData.logisticLineNumber =
      logisticReceiptLineData.logisticOrderLineNumber;
    logisticReceiptRollLineData.fabricStyleCode =
      logisticReceiptLineData.fabricStyleCode;
    logisticReceiptRollLineData.fabricStyleName =
      logisticReceiptLineData.fabricStyleName;
    logisticReceiptRollLineData.widthCode = logisticReceiptLineData.widthCode;
    logisticReceiptRollLineData.uomCode = logisticReceiptLineData.uomCode;
    logisticReceiptRollLineData.colorCode = logisticReceiptLineData.colorCode;
    logisticReceiptRollLineData.skuNumber = logisticReceiptLineData.skuNumber;
    logisticReceiptRollLineData.inventoryUomCode =
      logisticReceiptLineData.inventoryUomCode;
    logisticReceiptRollLineData.uomConversionRate =
      logisticReceiptLineData.uomConversionRate;
    logisticReceiptRollLineData.locationCode = DEFAULT_WAREHOUSE;
    logisticReceiptRollLineData.rollNumber = 0;
    logisticReceiptRollLineData.projectNumber =
      logisticReceiptData.projectNumber;

    this.setState({
      logisticReceiptRollLineData: logisticReceiptRollLineData,
    });
  };

  addNewRollLine = (e) => {
    if (e.detail == 1) {
      this.setDefaultValue();
      this.setState({ isShowRollLinePopup: true });
    }
  };

  onRollLineChange = (e) => {
    let logisticReceiptRollLineData = this.state.logisticReceiptRollLineData;
    logisticReceiptRollLineData[e.target.name] = e.target.value;
    if (e.target.name === "receivedQuantity") {
      logisticReceiptRollLineData["inventoryReceivedQuantity"] = e.target.value;
    }
    this.setState({ logisticReceiptRollLineData: logisticReceiptRollLineData });
  };
  getReceiptRollLineData = (e, val, rowData) => {
    if (e.detail == 1) {
      const logisticReceiptRollLineData = { ...rowData };
      this.setState({
        logisticReceiptRollLineData: logisticReceiptRollLineData,
        isShowRollLinePopup: true,
      });
    }
  };
  reArrangeRollLines = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.logisticRollLineNumber = maxLineNumber;
    });
  };
  deleteReceiptRollLine = (e, rowData) => {
    if (e.detail == 1) {
      const logisticReceiptLineData = { ...this.state.logisticReceiptLineData };
      let receiptRollLines = [...this.state.receiptRollLines];
      const row_Data = { ...rowData };
      if (!isEmptyArray(receiptRollLines)) {
        let result = receiptRollLines.filter(
          (ln) => ln.logisticRollLineNumber != row_Data.logisticRollLineNumber
        );
        let receivedQty = 0;
        if (!isEmptyArray(result)) {
          result.map((roll) => {
            receivedQty = receivedQty + parseFloat(roll.receivedQuantity);
          });
        }
        this.reArrangeRollLines(result);
        logisticReceiptLineData.receivedQuantity =
          parseFloat(receivedQty).toFixed(2);
        logisticReceiptLineData.totalRolls = result.length;
        this.setState({
          receiptRollLines: result,
          logisticReceiptLineData: logisticReceiptLineData,
        });
      }
    }
  };
  onLineChange = (e) => {
    let logisticReceiptLineData = this.state.logisticReceiptLineData;
    logisticReceiptLineData[e.target.name] = e.target.value;
    this.setState({
      logisticReceiptLineData: logisticReceiptLineData,
    });
  };
  /**** RollLine location lookup */

  onRollLineLocationChange = (e) => {
    let locationCode = e.target.value;
    this.state.isShowAutoCompleteRollLineLocationList = true;
    let tempData = this.state.logisticReceiptRollLineData;
    let showAutoCompleteList =
      this.state.isShowAutoCompleteRollLineLocationList;
    if (isEmpty(locationCode)) {
      this.state.isShowAutoCompleteRollLineLocationList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteRollLineLocationList;
      let tempData = this.state.logisticReceiptRollLineData;
      tempData.locationCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteRollLineLocationList: showAutoCompleteList,
        logisticReceiptRollLineData: tempData,
        rollLinelocationPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "locationCode" &&
      showAutoCompleteList === true &&
      locationCode !== ""
    ) {
      this.readRollLineLocationBySearchString(e.target.value);
      this.readRollLineLocation(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ logisticReceiptRollLineData: tempData });
  };
  rollLinelocationEnterKeyEventHandler = (e) => {
    this.readRollLineLocation(e.target.value);
    this.state.isShowAutoCompleteRollLineLocationList = false;
    let showAutoCompleteList =
      this.state.isShowAutoCompleteRollLineLocationList;
    this.setState({
      rollLinelocationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoCompleteRollLineLocationList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteRollLineLocationList: isShowAutoCompleteList,
    });
  };
  readRollLineLocationBySearchString = (searchString) => {
    let locationData = this.state.wareHouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((obj) => {
        let locationBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      rollLinelocationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readRollLineLocation = (locationCode) => {
    let tempData = this.state.logisticReceiptRollLineData;
    let locationBean = null;
    let locationData = null;
    this.state.wareHouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      tempData.locationCode = locationBean.code;
      this.state.isShowAutoCompleteRollLineLocationList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteRollLineLocationList;
      this.setState({
        logisticReceiptRollLineData: tempData,
        isShowAutoCompleteRollLineLocationList: showAutoCompleteList,
      });
    }
  };
  handleApproveResponse = (response) => {
    let success = false;
    let infoMsg = "";
    let errMsg = "";
    let errList = [];
    if (!isEmpty(response.mainOperationResponse)) {
      if (!isEmptyArray(response.mainOperationResponse.errors)) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        success = false;
      }
      if (!isEmptyArray(response.mainOperationResponse.infos)) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );
        success = true;
      }
    }
    if (!isEmpty(response.additionalOperationResponse)) {
      if (!isEmptyArray(response.additionalOperationResponse.errors)) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        success = false;
      }
      if (!isEmptyArray(response.additionalOperationResponse.infos)) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );
        success = true;
      }
    }
    if (!isEmptyArray(errList) && errList.length > 0) success = false;
    if (!isEmptyString(infoMsg) && !isEmptyString(errMsg)) {
      let msg = infoMsg + errMsg;
      let successMsg = [];
      successMsg.push(msg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(infoMsg)) {
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(errMsg)) {
      let errorMsg = [];
      errorMsg.push(errMsg);
      this.setState({
        alertMessage: errorMsg,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({ error_list: errList });
    return success;
  };
  approveResponse = (response) => {
    let isSuccess = this.handleApproveResponse(response.data);
    if (isSuccess) {
      if (
        !isEmpty(response.data) &&
        !isEmpty(response.data.mainOperationResponse) &&
        !isEmpty(response.data.mainOperationResponse.logisticOrderReceipt)
      ) {
        const logisticReceiptData =
          response.data.mainOperationResponse.logisticOrderReceipt;
        if (!this.isLocked) {
          this.editLogisticReceipt(logisticReceiptData.code);
        } else {
          this.code = logisticReceiptData.code;
          this.unLockLogisticReceipt(logisticReceiptData.code);
        }
      }
    }
    this.setState({ isLoading: false, loadingText: "" });
  };
  validateData = (data) => {
    let isValidData = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.customerCode)) {
        let errMsg = "Customer is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.customerName)) {
        let errMsg = "CustomerName is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyArray(data.lines)) {
        let errMsg = "InBound Lines Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidData = true;
      this.setState({ isShowAlert: false });
    }
    return isValidData;
  };
  approveLogisticReceipt = (e) => {
    if (e.detail === 1) {
      this.setState({
        isLoading: true,
        loadingText: "Approving...",
      });
      const logisticReceiptData = this.state.logisticReceiptData;
      let isValidData = false;
      isValidData = this.validateData(logisticReceiptData);
      const input = new RestLogisticOrderReceiptRequest();
      input.orderReceipt = logisticReceiptData;
      logisticReceiptData.isFetched
        ? (input.isLockRequired = true)
        : (input.isLockRequired = false);
      if (isValidData) {
        if (logisticReceiptData.isFetched) {
          if (
            SecurityAccessManager.LogisticOrderReceiptApproval_IsAccessible() &&
            SecurityAccessManager.LogisticOrderReceiptUpdation_IsAccessible()
          ) {
            LogisticOrderReceiptService.updateAndApproveLogisticOrderReceipt(
              input,
              this.approveResponse,
              this.errorCallBack
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);
            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
        } else {
          if (
            SecurityAccessManager.LogisticOrderReceiptApproval_IsAccessible() &&
            SecurityAccessManager.LogisticOrderReceiptCreation_IsAccessible()
          ) {
            LogisticOrderReceiptService.createAndApproveLogisticOrderReceipt(
              input,
              this.approveResponse,
              this.errorCallBack
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);
            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
        }
      } else {
        this.setState({ isLoading: false, loadingText: "" });
      }
    }
  };
  readUnApproveReasonBySearchString(searchString) {
    let reasonData = this.state.unapprovalReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(searchString.toLowerCase()) > -1
    );
    this.setState({
      unApproveReasonPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  onUnApproveReasonChange = (e) => {
    const code = e.target.value;
    this.state.showAutoCompleteUnApproveReasonList = true;
    const reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteUnApproveReasonList;
    if (isEmpty(code)) {
      this.state.showAutoCompleteUnApproveReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteUnApproveReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteUnApproveReasonList: showAutoCompleteList,
        reasonData: reason,
        unApproveReasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readUnApproveReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.unapprovalReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteUnApproveReasonList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteUnApproveReasonList;
          this.setState({
            showAutoCompleteUnApproveReasonList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ reasonData: reasonData });
  };
  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };
  unApproveReasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    reasonData["code"] = e.target.value;
    let reasonList = this.state.unapprovalReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        unApproveReasonPageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteUnApproveReasonList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteUnApproveReasonList: showAutoCompleteList,
    });
  };
  unApproveResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleResponse(response.data);
    if (
      !isEmpty(response) &&
      !isEmpty(response.data) &&
      !isEmpty(response.data.logisticOrderReceipt)
    ) {
      const logisticReceiptData = response.data.logisticOrderReceipt;
      let pageTitle = this.moduleCaption + " - EDIT";
      this.setState({
        logisticReceiptData: logisticReceiptData,
        pageTitle: pageTitle,
      });
      if (this.isLocked) {
        this.code = logisticReceiptData.code;
        this.unLockLogisticReceipt(logisticReceiptData.code);
      }
    }
  };
  saveUnApprove = () => {
    this.setState({
      isLoading: true,
      loadingText: "UnApproving InBound Receipt",
    });
    const logisticReceiptData = this.state.logisticReceiptData;
    const request = new RestLogisticOrderReceiptRequest();
    request.orderReceipt = logisticReceiptData;
    request.reason = this.state.reasonData;
    if (SecurityAccessManager.LogisticOrderReceiptUnApproval_IsAccessible()) {
      LogisticOrderReceiptService.unApproveLogisticOrderReceipt(
        request,
        this.unApproveResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onUnApproveReasonContinue = () => {
    this.saveUnApprove();
    this.closeReasonModelCallBack();
  };
  onReasonChange = (e) => {
    this.state.showAutoCompleteReasonList = true;
    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;
    if (isEmpty(e.target.value)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && e.target.value !== "") {
      this.readReasonBySearchString(e.target.value);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.cancelReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }
    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.cancelReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(searchString.toLowerCase()) > -1
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    reasonData["code"] = e.target.value;
    let reasonList = this.state.cancelReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  cancelResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleApproveResponse(response.data);
    if (
      !isEmpty(response) &&
      !isEmpty(response.data) &&
      !isEmpty(response.data.mainOperationResponse) &&
      !isEmpty(response.data.mainOperationResponse.logisticOrderReceipt)
    ) {
      const logisticReceiptData =
        response.data.mainOperationResponse.logisticOrderReceipt;
      let pageTitle = this.moduleCaption + " - EDIT";
      this.setState({
        logisticReceiptData: logisticReceiptData,
        pageTitle: pageTitle,
      });
      this.code = logisticReceiptData.code;
      this.editLogisticReceipt(logisticReceiptData.code);
    }
  };
  saveAndcancel = () => {
    this.setState({
      isLoading: true,
      loadingText: "Cancelling....",
    });
    const logisticReceiptData = this.state.logisticReceiptData;
    const request = new RestLogisticOrderReceiptRequest();
    request.orderReceipt = logisticReceiptData;
    request.reason = this.state.reasonData;
    if (SecurityAccessManager.LogisticOrderReceiptCancel_IsAccessible()) {
      LogisticOrderReceiptService.cancelAndUnLockLogisticOrderReceiptAfterApproval(
        request,
        this.cancelResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isLoading: false,
        loadingText: "",
      });
    }
  };
  onCancelReasonContinue = () => {
    this.saveAndcancel();
    this.closeReasonModelCallBack();
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowCancelReasonPopup: true,
      });
    } else if (type === 2) {
      this.setState({
        isShowUnApproveReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
    });
  };
  closeReasonModelCallBack = () => {
    this.setState({
      isShowCancelReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowUnApproveReasonPopup: false,
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
    });
  };
  unApproveLogisticReceipt = (e) => {
    if (e.detail === 1) this.openReasonCapture(2);
  };
  cancelLogisticReceipt = (e) => {
    if (e.detail === 1) this.openReasonCapture(1);
  };
  custPriceResponse = (response) => {
    let customerServicesList = new Array();
    if (!isEmpty(response.data) && !isEmptyArray(response.data.services)) {
      customerServicesList.push(...response.data.services);
    }
    this.setState({
      customerServicesList: customerServicesList,
    });
  };
  readCustomerServices = () => {
    const request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = this.state.logisticReceiptData.customerCode;
    CustomerService.readCustomerServices(
      request,
      this.custPriceResponse,
      this.errorCallBack
    );
  };
  // createInvoice = (e) => {
  //   if (e.detail === 1) {
  //     this.readCustomerServices();
  //     this.setState({ isShowCreateInvoicePopup: true });
  //   }
  // };
  warningMessageForInvoice = () => {
    this.setState({ isShowWarningMsgPopup: true });
  };
  closeMessageModelCallBack = () => {
    this.setState({ isShowWarningMsgPopup: false });
  };
  onYesButtonClick = () => {
    this.openInvoiceForm();
    this.closeMessageModelCallBack();
  };
  onNoButtonClick = () => {
    this.closeMessageModelCallBack();
  };

  handleInvoiceListResponse = (response) => {
    let invoiceNumber = "";
    let receiptNumber = this.state.logisticReceiptData.code;
    if (
      !isEmpty(response.data) &&
      // && !isEmpty(response.data.receipt)
      response.data.isSuccess
    ) {
      if (!isEmptyArray(response.data.invoices)) {
        response.data.invoices.map((ln, idx) => {
          invoiceNumber += idx === 0 ? ln.code : `${", " + ln.code}`;
          // invoiceNumber += ", ";
          // invoiceNumber += ln.code;
        });
        // let invoiceNumber = this.state.cmData.invoiceNumber;
        let displayMessage =
          " Following Receipt already Create this Invoice# [ " +
          invoiceNumber +
          " ] Receipt [" +
          receiptNumber +
          "] Do You Want to Continue ?";
        this.setState({ invoiceWarningMessage: displayMessage });
        this.warningMessageForInvoice();
      } else {
        this.openInvoiceForm();
      }
    }
  };
  checkForInvoices = () => {
    const request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = this.state.logisticReceiptData.code;
    LogisticOrderReceiptService.getLogisticOrderReceiptInvoiceList(
      request,
      this.handleInvoiceListResponse,
      this.errorCallBack
    );
  };
  createInvoice = (e) => {
    if (e.detail === 1) {
      this.checkForInvoices();
    }
  };
  openInvoiceForm = () => {
    this.readCustomerServices();
    this.setState({ isShowCreateInvoicePopup: true });
  };
  validateRollLines = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.locationCode)) {
        let errMsg = "Location is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (data.receivedQuantity <= 0 && isEmpty(data.receivedQuantity)) {
        let errMsg = "Received Qty is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      // if (isEmptyString(data.rollNumber) && !this.state.is3PL) {
      //   let errMsg = "Roll is Required";
      //   errorMessage = errorMessage + errMsg;
      //   err_list.push(errMsg);
      // }

      if (isEmptyArray(data.customerLotNumber)) {
        let errMsg = "CustomerLot Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl5: true,
      });
    } else {
      isValid = true;
      this.setState({ isShowAlertLvl5: false });
    }
    return isValid;
  };
  getMaxRollLineNumber = (receiptRollLines) => {
    let maxLineNumber = 0;
    if (!isEmptyArray(receiptRollLines)) {
      receiptRollLines.map((line) => {
        if (line.logisticRollLineNumber > maxLineNumber) {
          maxLineNumber = line.logisticRollLineNumber;
        }
      });
    }
    return maxLineNumber;
  };
  clearRollLineData = (e, isRequired) => {
    if (e.detail === 1) {
      if (isRequired) {
        this.setDefaultValue();
      } else {
        this.setState({
          logisticReceiptRollLineData: new LogisticOrderReceiptRollLineBean(),
        });
      }
    }
  };
  addOrUpdateRollLine = (e) => {
    if (e.detail === 1) {
      let logisticReceiptLineData = { ...this.state.logisticReceiptLineData };

      let logisticReceiptRollLineData = {
        ...this.state.logisticReceiptRollLineData,
      };
      // logisticReceiptRollLineData.inventoryReceivedQuantity =
      //   logisticReceiptRollLineData.receivedQuantity *
      //   logisticReceiptRollLineData.uomConversionRate;
      let receiptRollLines = [...this.state.receiptRollLines];

      let receivedQty = 0;
      let isValidLine = false;
      isValidLine = this.validateRollLines(logisticReceiptRollLineData);
      if (isValidLine) {
        let lineFound = false;
        var lineNumber = this.getMaxRollLineNumber(receiptRollLines);
        if (!isEmptyArray(receiptRollLines)) {
          receiptRollLines.map((line, i) => {
            if (
              line.logisticRollLineNumber ==
              logisticReceiptRollLineData.logisticRollLineNumber
            ) {
              logisticReceiptRollLineData.logisticRollLineNumber =
                line.logisticRollLineNumber;
              logisticReceiptRollLineData.isFetched = line.isFetched;
              receiptRollLines[i] = logisticReceiptRollLineData;
              lineFound = true;
            }

            // receivedQty += parseFloat(line.receivedQuantity);
          });
        }
        if (!lineFound) {
          logisticReceiptRollLineData.logisticRollLineNumber = ++lineNumber;
          receiptRollLines.push(logisticReceiptRollLineData);
          // receivedQty += parseFloat(
          //   logisticReceiptRollLineData.receivedQuantity
          // );
        }
        receiptRollLines.map((ln, i) => {
          receivedQty += parseFloat(ln.receivedQuantity);
        });

        logisticReceiptLineData.receivedQuantity =
          parseFloat(receivedQty).toFixed(2);
        logisticReceiptLineData.totalRolls = receiptRollLines.length;

        this.setState({
          receiptRollLines: receiptRollLines,
          logisticReceiptLineData: logisticReceiptLineData,
          isShowRollLinePopup: false,
        });
        this.clearRollLineData(e, false);
      }
    }
  };
  validateLines = () => {
    let isValid = true;
    return isValid;
  };
  clearLineData = () => {
    this.setState({
      logisticReceiptLineData: new LogisticOrderReceiptLineBean(),
      receiptRollLines: new Array(),
    });
  };
  addOrUpdateLine = (e) => {
    if (e.detail === 1) {
      const logisticReceiptLineData = { ...this.state.logisticReceiptLineData };
      const logisticReceiptData = { ...this.state.logisticReceiptData };
      const receiptRollLines = [...this.state.receiptRollLines];
      let isValidLine = false;
      isValidLine = this.validateLines(logisticReceiptLineData);
      if (isValidLine) {
        let lineFound = false;
        if (
          !isEmpty(logisticReceiptData) &&
          !isEmptyArray(logisticReceiptData.lines)
        ) {
          logisticReceiptData.lines.map((line, i) => {
            if (line.lineNumber == logisticReceiptLineData.lineNumber) {
              logisticReceiptLineData.lineNumber = line.lineNumber;
              logisticReceiptLineData.isFetched = line.isFetched;
              logisticReceiptLineData.receiptRollLines = receiptRollLines;
              // logisticReceiptLineData.receivedQuantity
              logisticReceiptData.lines[i] = logisticReceiptLineData;
              lineFound = true;
            }
          });
        }
        this.setState({
          logisticReceiptLineData: logisticReceiptLineData,
          isShowLinePopup: false,
        });
        this.clearLineData();
      }
    }
  };
  closeAlertModalCallBacklvl2 = (isShowPopup) => {
    this.setState({
      invoiceServiceLineList: [],
      isShowCreateInvoicePopup: isShowPopup,
      isShowPopupAlertlvl2: isShowPopup,
    });
  };
  hideAlertCallBacklvl2 = (msgType, isDisplayed) => {
    this.setState({ isShowPopupAlertlvl2: isDisplayed });
  };
  createInvoiceResponse = (response) => {
    if (response.data != null && response.data.invoice != null) {
      this.handleResponse(response.data);
      if (this.isLocked) {
        this.code = this.state.moduleKeyCode;
        this.unLockLogisticReceipt(this.state.moduleKeyCode);
      }
    }
  };
  createInvoiceFromReceipt = (e) => {
    if (e.detail == 1) {
      let logisticReceiptData = this.state.logisticReceiptData;
      let serviceLines = this.state.invoiceServiceLineList;
      let request = new LogisticReceiptToInvoiceInputBean();
      request.logisticReceipts = logisticReceiptData;
      request.serviceLines = serviceLines;
      LogisticOrderReceiptService.createInvoiceFromLogisticOrderReceipt(
        request,
        this.createInvoiceResponse,
        this.errorCallBack
      );

      this.closeAlertModalCallBacklvl2(false);
    }
  };
  serviceLineOnchange = (e) => {
    let invoiceServiceLineData = this.state.invoiceServiceLineData;
    invoiceServiceLineData[e.target.name] = e.target.value;
    if (e.target.name == "quantity") {
      invoiceServiceLineData.amount =
        invoiceServiceLineData.unitPrice * e.target.value;
    }
    this.setState({ invoiceServiceLineData: invoiceServiceLineData });
  };
  getLineNumber = () => {
    let maxLineNumber = 0;
    let invoiceServiceLineList = this.state.invoiceServiceLineList;
    if (!isEmptyArray(invoiceServiceLineList)) {
      invoiceServiceLineList.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  };
  validate = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.serviceCode)) {
        let errMsg = "ServiceCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.amount)) {
        let errMsg = "Amount is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.uomCode)) {
        let errMsg = "UomCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.unitPrice)) {
        let errMsg = "Price is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.quantity)) {
        let errMsg = "Qty is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowPopupAlertlvl2: true,
      });
    } else {
      isValid = true;
    }
    return isValid;
  };
  addLines = (e) => {
    if (e.detail <= 1) {
      let invoiceServiceLineList = this.state.invoiceServiceLineList;
      let invoiceServiceLineData = this.state.invoiceServiceLineData;
      invoiceServiceLineData.companyCode = this.companyCode;
      let isValid = false;
      isValid = this.validate(invoiceServiceLineData);

      if (isValid) {
        var lineNumber = this.getLineNumber();
        let isLineFound = false;
        if (!isEmptyArray(invoiceServiceLineList)) {
          invoiceServiceLineList.map((ln, i) => {
            if (ln.lineNumber == invoiceServiceLineData.lineNumber) {
              invoiceServiceLineData.isFetched = ln.isFetched;
              invoiceServiceLineList[i] = invoiceServiceLineData;
              isLineFound = true;
            }
          });
        }
        if (!isLineFound) {
          invoiceServiceLineData.lineNumber = ++lineNumber;
          invoiceServiceLineData.lineStatus =
            LogicConstants.INVOICE_SERVICE_LINE_OPEN_STATUS;
          invoiceServiceLineList.push(invoiceServiceLineData);
        }
        this.setState({
          invoiceServiceLineList: invoiceServiceLineList,
        });
        this.clearLines(e);
      }
    }
  };
  clearLines = (e) => {
    if (e.detail == 1) {
      let invoiceServiceLineData = new InvoiceServiceLineBean();
      this.setState({ invoiceServiceLineData: invoiceServiceLineData });
    }
  };
  reArrangeLines = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  deleteService = (e, rowData) => {
    if (e.detail == 1) {
      let invoiceServiceLineList = this.state.invoiceServiceLineList;
      var index = invoiceServiceLineList.indexOf(rowData);
      if (index > -1) {
        invoiceServiceLineList.splice(index, 1);
        this.reArrangeLines(invoiceServiceLineList);
        this.setState({ invoiceServiceLineList: invoiceServiceLineList });
      }
    }
  };
  editService = (e, data, rowData) => {
    if (e.detail == 1) {
      const invoiceServiceLineData = { ...rowData };
      invoiceServiceLineData.companyCode = this.companyCode;
      this.setState({ invoiceServiceLineData: invoiceServiceLineData });
    }
  };
  serviceOnChange = (e) => {
    let serviceCode = e.target.value;
    this.state.isShowAutoCompleteServiceList = true;
    let tempData = this.state.invoiceServiceLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
    if (isEmpty(serviceCode)) {
      this.state.isShowAutoCompleteServiceList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
      let tempData = this.state.invoiceServiceLineData;
      tempData.serviceCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteServiceList: showAutoCompleteList,
        invoiceServiceLineData: tempData,
        servicePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "serviceCode" &&
      showAutoCompleteList === true &&
      serviceCode !== ""
    ) {
      this.readServiceBySearchString(e.target.value);
      this.readService(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ invoiceServiceLineData: tempData });
  };
  serviceEnterKeyEvent = (e) => {
    this.readService(e.target.value);
    this.state.isShowAutoCompleteServiceList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
    this.setState({
      servicePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteServiceList: showAutoCompleteList,
    });
  };
  displayServiceAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteServiceList: isShowAutoCompleteList,
    });
  };
  readServiceBySearchString = (searchString) => {
    let serviceData = this.state.services;
    let simpleAutoCompleteList = new Array();
    if (serviceData.length > 0 && serviceData != null) {
      serviceData.map((obj) => {
        let serivceBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(serivceBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      servicePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readService = (serviceCode) => {
    let tempData = this.state.invoiceServiceLineData;
    let serivceBean = null;
    let serviceData = null;
    this.state.services.map((ln) => {
      if (ln.code === serviceCode) {
        serivceBean = ln;
        serviceData = new BaseBean();
        serviceData.code = ln.code;
        serviceData.description = ln.description;
      }
    });
    if (!isEmpty(serivceBean)) {
      const customerServicesList = this.state.customerServicesList;
      let service_bean = new BaseBean();
      if (!isEmptyArray(customerServicesList)) {
        const result = customerServicesList.filter(
          (service) => service.code === serviceCode
        );
        service_bean = result[0];
      }
      tempData.serviceCode = serivceBean.code;
      tempData.serviceName = serivceBean.description;
      tempData.uomCode = serivceBean.uomCode;
      if (
        !isEmpty(service_bean) &&
        service_bean.price != null &&
        service_bean.price > 0
      )
        tempData.unitPrice = service_bean.price;
      else tempData.unitPrice = serivceBean.price;
      this.state.isShowAutoCompleteServiceList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
      this.setState({
        invoiceServiceLineData: tempData,
        isShowAutoCompleteServiceList: showAutoCompleteList,
      });
    }
  };
  getHeaderView() {
    return (
      <LogisticReceiptEntryForm
        {...this.state}
        onChange={this.onChange}
        onLocationChange={this.onLocationChange}
        locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
        displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
        getLogisticReceiptLine={this.getLogisticReceiptLine}
        onLogisticOrderChange={this.onLogisticOrderChange}
        logisticOrderEnterKeyEventHandler={
          this.logisticOrderEnterKeyEventHandler
        }
        displayAutoCompleteLogisticOrderList={
          this.displayAutoCompleteLogisticOrderList
        }
        lnkLogisticOrderModule={this.lnkLogisticOrderModule}
        closeAlertModalCallBackLvl1={this.closeAlertModalCallBackLvl1}
        hideAlertCallBackLvl1={this.hideAlertCallBackLvl1}
        closeAlertModalCallBackLvl5={this.closeAlertModalCallBackLvl5}
        hideAlertCallBackLvl5={this.hideAlertCallBackLvl5}
        showToast={this.showToast}
        openImagePopup={this.openImagePopup}
        deleteItemImage={this.deleteItemImage}
        uploadImage={this.uploadImage}
        setMainUrl={this.setMainUrl}
        setWebUrl={this.setWebUrl}
        setFrontUrl={this.setFrontUrl}
        setBackUrl={this.setBackUrl}
        setMainImg={this.setMainImg}
        setWebImg={this.setWebImg}
        setFrontImg={this.setFrontImg}
        setBackImg={this.setBackImg}
        openDocPopup={this.openDocPopup}
        addorUpdateDocData={this.addorUpdateDocData}
        uploadDoc={this.uploadDoc}
        deleteDoc={this.deleteDoc}
        setDoc1Url={this.setDoc1Url}
        setDoc1Name={this.setDoc1Name}
        setDoc1Data={this.setDoc1Data}
        setDoc2Url={this.setDoc2Url}
        setDoc2Name={this.setDoc2Name}
        setDoc2Data={this.setDoc2Data}
        setDoc3Url={this.setDoc3Url}
        setDoc3Name={this.setDoc3Name}
        setDoc3Data={this.setDoc3Data}
        setDoc4Url={this.setDoc4Url}
        setDoc4Name={this.setDoc4Name}
        setDoc4Data={this.setDoc4Data}
        disableUpdatableFields={this.state.disableUpdatableFields}
        lnkFabricModule={this.lnkFabricModule}
        openItemPurchaseHistoryInq={this.openItemPurchaseHistoryInq}
        openItemCurrentInvInq={this.openItemCurrentInvInq}
        openItemInvPositionInq={this.openItemInvPositionInq}
      />
    );
  }

  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricModule: isOpen,
      isShowItemInventoryPositionInq: isOpen,
      isShowItemCurrentInventoryInq: isOpen,
      isShowFabricPurchaseHistoryInq: isOpen,

      moduleForPopup: [],
    });
  };

  openItemInvPositionInq = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowItemInventoryPositionInq: true,
          moduleForPopup: (
            <PopupFabricInventoryPositionInq
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  lnkFabricModule = (e, code) => {
    if (e.detail === 1) {
      // let logisticOrderLineData = this.state.logisticOrderLineData;
      // let code = logisticOrderLineData.fabricStyleCode;
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricModule: true,
          moduleForPopup: (
            <PopupFabricModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  openItemCurrentInvInq = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowItemCurrentInventoryInq: true,
          moduleForPopup: (
            <PopupItemCurrentInventoryInq
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  openItemPurchaseHistoryInq = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowFabricPurchaseHistoryInq: true,
          moduleForPopup: (
            <PopupFabricPurchaseHistoryInq
              fabricCode={code}
              // vendorCode={vendorCode}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  getHistoryView() {
    return <LogisticReceiptHistoryForm {...this.state} />;
  }
  getInvoiceView() {
    return <LogisticReceiptInvoiceForm {...this.state} />;
  }

  getImageView = () => {
    return (
      <MutilpleImages
        {...this.state}
        logisticReceiptData={this.state.logisticReceiptData}
        onChange={this.onChange}
        showToast={this.showToast}
        setMultiImageUrl={this.setMultiImageUrl}
        setMultiImgData={this.setMultiImgData}
        uploadMutiImage={this.uploadMutiImage}
        deleteMutipleImage={this.deleteMutipleImage}
        //   onImageChange={this.onImageChange}
        addImageLines={this.addImageLines}
        clearImageLines={this.clearImageLines}
      />
    );
  };
  getDocumentView = () => {
    return (
      <MutilpleDocuments
        {...this.state}
        logisticReceiptData={this.state.logisticReceiptData}
        documents={this.state.documents}
        // onChange={this.onChange}
        showToast={this.showToast}
        uploadMutiDouments={this.uploadMutiDouments}
        uploadMutiDoumentsUrl={this.uploadMutiDoumentsUrl}
        deleteMultiDocument={this.deleteMultiDocument}
      />
    );
  };

  //--------------------------------------------------------Image And Document------------------------

  setMultiImageUrl = (url) => {
    setTimeout(() => {
      this.setState({
        preview_Url: url,
      });
    }, 300);
  };
  setMultiImgData = (data) => {
    // this.setState({

    setTimeout(() => {
      this.setState({
        images: data,
      });
    }, 400);
    //   images: data,
    // });
  };
  uploadMutiImage = (images) => {
    let logisticReceiptData = this.state.logisticReceiptData;
    let receiptImages = new Array();
    let imageData = null;
    for (const img of images) {
      if (!img.isFetched && !img.isDeleted) {
        imageData = new LogisticOrderReceiptImageBean();
        if (!isEmpty(img.imageCode)) {
          imageData.imageCode = img.imageCode;
          imageData.imageOritinalname = img.name;
          imageData.imageName = img.name;
          imageData.isFetched = true;
          imageData.isApplied = true;
        } else {
          imageData.imageOritinalname = img.name;
          imageData.imageName = img.name;
        }
        imageData.companyCode = this.companyCode;
        imageData.logisticOrderReceiptNumber = logisticReceiptData.code;
        receiptImages.push(imageData);
      } else {
        if (img.isFetched == true) {
          receiptImages.push(img);
        }
      }
    }
    logisticReceiptData.receiptImages = receiptImages;
    //   this.state.images = receiptImages;

    this.setState({
      logisticReceiptData: logisticReceiptData,
      images: images,
    });
  };
  deleteMutipleImage = (tempIndex) => {
    let orderImages = this.state.logisticReceiptData.receiptImages;
    if (!isEmptyArray(orderImages)) {
      for (let j = 0; j < orderImages.length; j++) {
        if (j === tempIndex) {
          if (orderImages[j].isFetched == true) {
            orderImages[j].deleted = true; // Change the value at index 2
            orderImages[j].isDeleted = true;
          } else {
            orderImages.splice(j, 1); // Change the value at index 2
            this.state.images.splice(j, 1);
          }
        }
      }
    }
    this.state.logisticReceiptData.receiptImages = orderImages;
  };
  addImageLines = (imageEntity) => {
    let logisticReceiptData = this.state.logisticReceiptData;
    logisticReceiptData.receiptImages.map((det) => {
      if (det.imageName == imageEntity.imageName) {
        det.tags = imageEntity.tags;
        det.notesCommunication = imageEntity.notesCommunication;
      }
    });
    this.setState({
      logisticReceiptData: logisticReceiptData,
    });
  };
  // clearImageLines
  clearImageLines = (imageEntity) => {
    let logisticReceiptData = this.state.logisticReceiptData;
    logisticReceiptData.receiptImages.map((det) => {
      if (det.imageName == imageEntity.imageName) {
        det.tags = "";
        det.notesCommunication = "";
      }
    });
    this.setState({
      logisticReceiptData: logisticReceiptData,
    });
  };
  showToast = (msg, type) => {
    let errList = [];
    if (type === 1) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (type === 2) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showToast = (msg, type) => {
    let errList = [];
    if (type === 1) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (type === 2) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  uploadMutiDouments = (docs) => {
    let logisticReceiptData = this.state.logisticReceiptData;
    let documents = new Array();
    let docmentData = null;
    for (const doc of docs) {
      if (!doc.isFetched) {
        docmentData = new LogisticOrderReceiptDocumentBean();
        docmentData.documentOriginalname = doc.name;
        docmentData.documentName = doc.name;
        docmentData.companyCode = this.companyCode;
        docmentData.logisticOrderReceiptNumber = logisticReceiptData.code;
        docmentData.documentPath = DOCUMENT_CHANGED;
        documents.push(docmentData);
      } else {
        documents.push(doc);
      }
    }
    logisticReceiptData.logisticOrderReceiptDocuments = documents;
    this.setState({
      logisticReceiptData: logisticReceiptData,
      documents: docs,
    });
  };
  uploadMutiDoumentsUrl = (url) => {
    setTimeout(() => {
      this.setState({
        preview_Docs: url,
      });
    }, 400);
  };

  deleteMultiDocument = (rowData) => {
    let docs = this.state.logisticOrderData.logisticOrderDocuments;
    if (!isEmptyArray(docs)) {
      for (let j = 0; j < docs.length; j++) {
        if (docs[j].documentName === rowData.documentName) {
          if (docs[j].isFetched == true) {
            docs[j].deleted = true; // Change the value at index 2
            docs[j].isDeleted = true;
          } else {
            docs.splice(j, 1); // Change the value at index 2
            this.state.documents.splice(j, 1);
          }
        }
      }
    }
    this.state.logisticOrderData.logisticOrderDocuments = docs;
  };

  //-----------------------------------*************************************-------------------------------

  loadRollLines = (lines) => {
    let lineNumber = this.getMaxRollLineNumber(this.state.receiptRollLines);

    const logisticReceiptLineData = { ...this.state.logisticReceiptLineData };
    // let lineNumber = 0;
    const receiptRollLines = [...this.state.receiptRollLines];
    let rollLines = new Array();
    let receivedQuantity = logisticReceiptLineData.receivedQuantity;
    lines.map((ln) => {
      if (
        ln.fabricStyleCode === logisticReceiptLineData.fabricStyleCode &&
        ln.colorCode === logisticReceiptLineData.colorCode
      ) {
        const rollLineData = new LogisticOrderReceiptRollLineBean();
        rollLineData.companyCode = logisticReceiptLineData.companyCode;
        rollLineData.logisticRollLineNumber = ++lineNumber;
        rollLineData.logisticOrderReceiptNumber =
          logisticReceiptLineData.logisticOrderReceiptNumber;
        rollLineData.logisticLineNumber =
          logisticReceiptLineData.logisticOrderLineNumber;
        rollLineData.fabricStyleCode = logisticReceiptLineData.fabricStyleCode;
        rollLineData.fabricStyleName = logisticReceiptLineData.fabricStyleName;
        rollLineData.widthCode = logisticReceiptLineData.widthCode;
        rollLineData.uomCode = logisticReceiptLineData.uomCode;
        rollLineData.colorCode = logisticReceiptLineData.colorCode;
        rollLineData.skuNumber = logisticReceiptLineData.skuNumber;
        rollLineData.inventoryUomCode =
          logisticReceiptLineData.inventoryUomCode;
        rollLineData.uomConversionRate =
          logisticReceiptLineData.uomConversionRate;
        rollLineData.locationCode = DEFAULT_WAREHOUSE;
        rollLineData.rollNumber = ln.rollNumber;
        rollLineData.boxNumber = ln.boxNumber;
        rollLineData.customerLotNumber = ln.lotNumber;
        rollLineData.upcNumber = ln.upcCode;
        rollLineData.infoText = ln.infoText;
        rollLineData.aisleInfoText = ln.aisleInfoText;
        rollLineData.palletNumber = ln.palletNumber;
        rollLineData.imeiNumber = ln.imeiNumber;
        rollLineData.projectNumber = ln.projectNumber;
        rollLineData.inventoryReceivedQuantity = parseFloat(
          ln.quantity
        ).toFixed(2);
        rollLineData.receivedQuantity = parseFloat(ln.quantity).toFixed(2);
        receiptRollLines.push(rollLineData);
        receivedQuantity += parseFloat(rollLineData.receivedQuantity);
      }
    });

    // receiptRollLines.push(rollLines);

    logisticReceiptLineData.receivedQuantity =
      parseFloat(receivedQuantity).toFixed(2);
    logisticReceiptLineData.totalRolls = receiptRollLines.length;

    this.setState({
      receiptRollLines: receiptRollLines,
      logisticReceiptLineData: logisticReceiptLineData,
    });
  };
  getLineDataExcelResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.einput) &&
      !isEmptyArray(response.data.einput.rollLines)
    ) {
      let rollLines = new Array();
      rollLines = response.data.einput.rollLines;
      this.loadRollLines(rollLines);
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  getLinesDatasFromExcel = () => {
    this.setState({
      isLoading: true,
      loadingText: "Loading Excel Data",
    });
    let logisticReceiptLineData = this.state.logisticReceiptLineData;
    let selectedDocument = this.state.selectedDocument;
    let readrestInput = new RestLogisticReceiptRollLineExcelImportRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.logisticOrderNumber =
      logisticReceiptLineData.logisticOrderNumber;
    readrestInput.excelFileName = selectedDocument;
    if (SecurityAccessManager.LogesticReceipt_IsAccessible()) {
      LogisticOrderReceiptService.getLogisticOrderReceiptRollLinesDatasFromExcel(
        readrestInput,
        this.getLineDataExcelResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  uploadExcelFile = (e) => {
    let file = e.target.files[0];
    let fileName = file.name;
    let fileData = new File([file], `${fileName}`, { type: file.type });
    let formData = new FormData();
    formData.append("file", fileData);
    this.setState({ selectedDocument: fileName });
    if (SecurityAccessManager.LogesticReceipt_IsAccessible()) {
      LogisticOrderReceiptService.uploadExcelInput(
        formData,
        this.uploadRollLineExcelResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  uploadRollLineExcelResponse = (response) => {
    if (response.data != null) {
      if (response.data.success == true) {
        this.getLinesDatasFromExcel();
      }
    }
  };

  /* image popup */
  openImagePopup = (e) => {
    this.setState({ isShowItemImagePopup: true });
  };
  deleteItemImage = (imagePart) => {
    const entity__Data = { ...this.state.logisticReceiptData };

    if (!isEmptyArray(entity__Data.receiptImages)) {
      entity__Data.receiptImages.map((img) => {
        if (img.imagePart === imagePart) {
          img.imageOritinalname = null;
          img.isDeleted = true;
        }
      });
    }

    if (imagePart === MAIN_IMAGE_PART) {
      this.setMainUrl("");
    } else if (imagePart == WEB_IMAGE_PART) {
      this.setWebUrl("");
    } else if (imagePart == FRONT_IMAGE_PART) {
      this.setFrontUrl("");
    } else if (imagePart == BACK_IMAGE_PART) {
      this.setBackUrl("");
    }

    this.setState({ logisticReceiptData: entity__Data });
  };
  uploadImage = (file, imagePart) => {
    if (file) {
      const entity__Data = { ...this.state.logisticReceiptData };

      let itemImg__Data = null;

      if (!isEmptyArray(entity__Data.receiptImages)) {
        entity__Data.receiptImages.map((img) => {
          if (img.imagePart === imagePart) {
            itemImg__Data = { ...img };
          }
        });
      }
      if (!isEmpty(itemImg__Data)) {
        itemImg__Data.imageOritinalname = file.name;
      } else {
        itemImg__Data = new LogisticOrderReceiptImageBean();
        // itemImg__Data = {};
        itemImg__Data.imagePart = imagePart;
        itemImg__Data.imageOritinalname = file.name;
        itemImg__Data.imageName = file.name;
        itemImg__Data.companyCode = this.companyCode;
        itemImg__Data.logisticOrderReceiptNumber = entity__Data.code;
        entity__Data.receiptImages.push(itemImg__Data);
      }

      this.setState({
        logisticReceiptData: entity__Data,
      });
    }
  };

  imageUploadResponse = (response) => {};

  toServer = (file, fileName) => {
    let image = new File([file], `${fileName}`, { type: file.type });
    const formData = new FormData();
    formData.append("file", image);
    LogisticOrderReceiptService.logisticReceiptImageUpload(
      formData,
      this.imageUploadResponse,
      this.errorCallBack
    );
  };

  // uploadImagesToServer = () => {
  //   const entity__Data = { ...this.state.logisticReceiptData };

  //   const main__Img = this.state.mainImgData;
  //   const web__Img = this.state.webImgData;
  //   const front__Img = this.state.frontImgData;
  //   const Back__Img = this.state.BackImgData;

  //   if (!isEmptyArray(entity__Data.receiptImages)) {
  //     entity__Data.receiptImages.map((imgData) => {
  //       if (imgData.imagePart == MAIN_IMAGE_PART && imgData.isDeleted != true) {
  //         if (main__Img != null) this.toServer(main__Img, imgData.imageName);
  //       } else if (
  //         imgData.imagePart == WEB_IMAGE_PART &&
  //         imgData.isDeleted != true
  //       ) {
  //         if (web__Img != null) this.toServer(web__Img, imgData.imageName);
  //       } else if (
  //         imgData.imagePart == FRONT_IMAGE_PART &&
  //         imgData.isDeleted != true
  //       ) {
  //         if (front__Img != null) this.toServer(front__Img, imgData.imageName);
  //       } else if (
  //         imgData.imagePart == BACK_IMAGE_PART &&
  //         imgData.isDeleted != true
  //       ) {
  //         if (Back__Img != null) this.toServer(Back__Img, imgData.imageName);
  //       }
  //     });
  //   }
  // };

  uploadImagesToServer = () => {
    const entity__Data = { ...this.state.logisticReceiptData };
    const images = this.state.images;
    if (!isEmptyArray(entity__Data.receiptImages)) {
      entity__Data.receiptImages.map((img) => {
        if (img.isDeleted != true && img.isFetched != true) {
          images.map((imgData) => {
            if (img.imageOritinalname == imgData.name) {
              this.toServer(imgData, img.imageName);
            }
          });
        } else if (img.isFetched == true && img.isApplied == true) {
          images.map((imgData) => {
            if (img.imageOritinalname == imgData.name) {
              this.toServer(imgData, img.imageName);
            }
          });
        }
      });
    }
    // }
  };
  getImageURL = () => {
    const { appData } = this.context;

    return appData.serviceURL + "/" + "logisticReceiptImages?file=";
  };

  setMainUrl = (url) => {
    setTimeout(() => {
      this.setState({
        mainImageUrl: url,
      });
    }, 2000);
  };
  setWebUrl = (url) => {
    setTimeout(() => {
      this.setState({
        webImageUrl: url,
      });
    }, 2000);
  };
  setFrontUrl = (url) => {
    setTimeout(() => {
      this.setState({
        frontImageUrl: url,
      });
    }, 2000);
  };
  setBackUrl = (url) => {
    setTimeout(() => {
      this.setState({
        backImageUrl: url,
      });
    }, 2000);
  };
  setMainImg = (data) => {
    this.setState({
      mainImgData: data,
    });
  };
  setWebImg = (data) => {
    this.setState({
      webImgData: data,
    });
  };
  setFrontImg = (data) => {
    this.setState({
      frontImgData: data,
    });
  };
  setBackImg = (data) => {
    this.setState({
      BackImgData: data,
    });
  };

  /* document popup */

  openDocPopup = () => {
    this.setState({
      isShowItemDocPopup: true,
    });
  };

  addorUpdateDocData = () => {
    this.setState({
      isShowItemDocPopup: false,
    });
  };

  uploadDoc = (file, type) => {
    if (file) {
      const entity__Data = { ...this.state.logisticReceiptData };

      let itemDoc__Data = null;

      // let documentNumber = 1;
      if (!isEmptyArray(entity__Data.logisticOrderReceiptDocuments)) {
        entity__Data.logisticOrderReceiptDocuments.map((doc) => {
          if (doc.documentNumber == type) {
            itemDoc__Data = { ...doc };
          }
          // documentNumber++;
        });
      }
      if (!isEmpty(itemDoc__Data)) {
        itemDoc__Data.documentPath = DOCUMENT_CHANGED;
        itemDoc__Data.documentName = file.name;
        itemDoc__Data.documentOriginalname = file.name;
      } else {
        itemDoc__Data = new LogisticOrderReceiptDocumentBean();

        itemDoc__Data.logisticOrderReceiptNumber = entity__Data.code;
        itemDoc__Data.companyCode = this.companyCode;
        itemDoc__Data.documentOriginalname = file.name;
        itemDoc__Data.documentNumber = type;
        itemDoc__Data.documentPath = DOCUMENT_CHANGED;
        itemDoc__Data.documentName = file.name;

        entity__Data.logisticOrderReceiptDocuments.push(itemDoc__Data);
      }

      this.setState({
        logisticReceiptData: entity__Data,
      });
    }
  };
  deleteDoc = (type) => {
    const entity__Data = { ...this.state.logisticReceiptData };

    if (!isEmptyArray(entity__Data.logisticOrderReceiptDocuments)) {
      entity__Data.logisticOrderReceiptDocuments.map((doc) => {
        if (doc.documentNumber === type) {
          doc.documentName = "";
          doc.documentPath = "";
          doc.isDeleted = true;
        }
      });
    }

    if (type == 1) {
    } else if (type == 2) {
    } else if (type == 3) {
    } else if (type == 4) {
    }
    this.setState({ logisticReceiptData: entity__Data });
  };

  documentUploadResponse = (response) => {};

  docToServer = (file, fileName) => {
    let document = new File([file], `${fileName}`, { type: file.type });
    const formData = new FormData();
    formData.append("file", document);
    LogisticOrderReceiptService.logisticReceiptDocUpload(
      formData,
      this.documentUploadResponse,
      this.errorCallBack
    );
  };

  uploadMultiDocsToServer = () => {
    const receiptData = { ...this.state.logisticReceiptData };
    const documents = this.state.documents;
    if (!isEmptyArray(receiptData.logisticOrderReceiptDocuments)) {
      receiptData.logisticOrderReceiptDocuments.map((doc) => {
        if (doc.isDeleted != true && doc.isFetched != true) {
          documents.map((docData) => {
            if (doc.documentOriginalname == docData.name) {
              this.docToServer(docData, doc.documentName);
            }
          });
        }
      });
    }
  };

  // uploadDocsToServer = () => {
  //   const entity__Data = { ...this.state.logisticReceiptData };

  //   const doc1__data = this.state.doc1Data;
  //   const doc2__data = this.state.doc2Data;
  //   const doc3__data = this.state.doc3Data;
  //   const doc4__data = this.state.doc4Data;

  //   if (!isEmptyArray(entity__Data.logisticOrderReceiptDocuments)) {
  //     entity__Data.logisticOrderReceiptDocuments.map((doc) => {
  //       if (doc.documentNumber == 1 && doc.isDeleted != true) {
  //         if (doc1__data != null)
  //           this.docToServer(doc1__data, doc.documentName);
  //       } else if (doc.documentNumber == 2 && doc.isDeleted != true) {
  //         if (doc2__data != null)
  //           this.docToServer(doc2__data, doc.documentName);
  //       } else if (doc.documentNumber == 3 && doc.isDeleted != true) {
  //         if (doc3__data != null)
  //           this.docToServer(doc3__data, doc.documentName);
  //       } else if (doc.documentNumber == 4 && doc.isDeleted != true) {
  //         if (doc4__data != null)
  //           this.docToServer(doc4__data, doc.documentName);
  //       }
  //     });
  //   }
  // };

  getDocURL = () => {
    const { appData } = this.context;
    return appData.serviceURL + "/" + "logisticReceiptDocs?file=";

    // return appData.serviceURL + "/" + process.env.REACT_APP_ITEM_DOC_PATH;
  };
  setDoc1Url = (url) => {
    setTimeout(() => {
      this.setState({
        doc1Url: url,
      });
    }, 2000);
  };
  setDoc2Url = (url) => {
    setTimeout(() => {
      this.setState({
        doc2Url: url,
      });
    }, 2000);
  };
  setDoc3Url = (url) => {
    setTimeout(() => {
      this.setState({
        doc3Url: url,
      });
    }, 2000);
  };
  setDoc4Url = (url) => {
    setTimeout(() => {
      this.setState({
        doc4Url: url,
      });
    }, 2000);
  };
  setDoc1Name = (name) => {
    this.setState({
      doc1Name: name,
    });
  };
  setDoc2Name = (name) => {
    this.setState({
      doc2Name: name,
    });
  };
  setDoc3Name = (name) => {
    this.setState({
      doc3Name: name,
    });
  };
  setDoc4Name = (name) => {
    this.setState({
      doc4Name: name,
    });
  };

  setDoc1Data = (data) => {
    this.setState({
      doc1Data: data,
    });
  };
  setDoc2Data = (data) => {
    this.setState({
      doc2Data: data,
    });
  };
  setDoc3Data = (data) => {
    this.setState({
      doc3Data: data,
    });
  };
  setDoc4Data = (data) => {
    this.setState({
      doc4Data: data,
    });
  };
  onFilterChange = (e) => {
    let criteria = this.state.logisticReceiptRollLineBeanFilter;
    criteria[e.target.name] = e.target.value;
    this.setState({ logisticReceiptRollLineBeanFilter: criteria });
  };
  filterRollLinenClick = (e) => {
    if (e.detail == 1) {
      let rollLineList = [...this.state.receiptRollLines];
      let rollLineData = { ...this.state.logisticReceiptRollLineBeanFilter };
      let logisticReceiptRollLines = [];
      logisticReceiptRollLines = rollLineList;
      if (
        isEmptyString(rollLineData.customerLotNumber) &&
        isEmptyString(rollLineData.upcNumber) &&
        rollLineData.receivedQuantity == 0
      ) {
        let errMsg = "Please Enter Filter Select Criteria";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowPopupAlert: true,
          isSearchCriteria: false,
          isResetCriteria: true,
          isShowFilterList: false,
        });
        // }
      } else {
        let rollList = [];
        rollLineList.map((ln) => {
          if (
            !isEmptyString(rollLineData.customerLotNumber) &&
            isEmptyString(rollLineData.upcNumber) &&
            rollLineData.receivedQuantity == 0
          ) {
            if (ln.customerLotNumber == rollLineData.customerLotNumber) {
              rollList.push(ln);
            }
          } else if (
            !isEmptyString(rollLineData.customerLotNumber) &&
            !isEmptyString(rollLineData.upcNumber) &&
            rollLineData.receivedQuantity == 0
          ) {
            if (
              ln.customerLotNumber == rollLineData.customerLotNumber &&
              ln.upcNumber == rollLineData.upcNumber
            ) {
              rollList.push(ln);
            }
          } else if (
            !isEmptyString(rollLineData.customerLotNumber) &&
            isEmptyString(rollLineData.upcNumber) &&
            rollLineData.receivedQuantity != 0
          ) {
            if (
              ln.customerLotNumber == rollLineData.customerLotNumber &&
              ln.receivedQuantity == rollLineData.receivedQuantity
            ) {
              rollList.push(ln);
            }
          } else if (
            !isEmptyString(rollLineData.customerLotNumber) &&
            !isEmptyString(rollLineData.upcNumber) &&
            rollLineData.receivedQuantity != 0
          ) {
            if (
              ln.customerLotNumber == rollLineData.customerLotNumber &&
              ln.upcNumber == rollLineData.upcNumber &&
              ln.receivedQuantity == rollLineData.receivedQuantity
            ) {
              rollList.push(ln);
            }
          } else if (
            isEmptyString(rollLineData.customerLotNumber) &&
            !isEmptyString(rollLineData.upcNumber) &&
            rollLineData.receivedQuantity != 0
          ) {
            if (
              ln.upcNumber == rollLineData.upcNumber &&
              ln.receivedQuantity == rollLineData.receivedQuantity
            ) {
              rollList.push(ln);
            }
          } else if (
            isEmptyString(rollLineData.customerLotNumber) &&
            !isEmptyString(rollLineData.upcNumber) &&
            rollLineData.receivedQuantity == 0
          ) {
            if (ln.upcNumber == rollLineData.upcNumber) {
              rollList.push(ln);
            }
          } else if (
            isEmptyString(rollLineData.customerLotNumber) &&
            isEmptyString(rollLineData.upcNumber) &&
            rollLineData.receivedQuantity != 0
          ) {
            if (ln.receivedQuantity == rollLineData.receivedQuantity) {
              rollList.push(ln);
            }
          }
        });

        this.setState({
          filterLogisticReceiptList: rollList,
          isSearchCriteria: true,
          isResetCriteria: false,
          isShowFilterList: true,
        });
      }
    }
  };

  resetReceiptRollLines = (e) => {
    if (e.detail == 1) {
      let logisticReceiptRollLineBeanFilter =
        new LogisticOrderReceiptRollLineBeanFilter();
      //let filterPurchaseList = this.state.filterPurchaseList;
      let tempArray = [];
      this.setState({
        logisticReceiptRollLineBeanFilter: logisticReceiptRollLineBeanFilter,
        filterLogisticReceiptList: tempArray,
        isSearchCriteria: false,
        isResetCriteria: true,
        isShowFilterList: false,
      });
    }
  };
  render() {
    const logisticReceiptData = this.state.logisticReceiptData;
    const invoiceServiceLineData = this.state.invoiceServiceLineData;
    const invoiceServiceLineList = this.state.invoiceServiceLineList;
    return (
      <div>
        <MessageBoxComponent
          isShowPopup={this.state.isShowWarningMsgPopup}
          ref={this.warningMessageDialogRef}
          warningMesage={this.state.invoiceWarningMessage}
          title="Warning Message"
          onYesButtonClick={this.onYesButtonClick}
          onNoButtonClick={this.onNoButtonClick}
          closeMessageModelCallBack={this.closeMessageModelCallBack}
        />
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editLogisticReceipt}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.logisticReceiptLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          disabled={this.state.disabled}
          selectButtonClick={this.selectButtonClick}
          isSpecialViewMode={this.state.isSpecialViewMode}
          isResetView={this.state.isResetView}
        />

        {!this.state.isLogisticReceiptListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              save={this.save}
              clearError={this.clearError}
              generatePDF={this.generatePDF}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              isShowPDFButton={this.state.isShowPDFReportButton}
              pageTitle={this.state.pageTitle}
              isSpecialViewMode={this.state.isSpecialViewMode}
              extend_toolbar={
                <>
                  {this.state.isShowExcelButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.generateExcel(e)}
                    >
                      <ExcelIcon />
                      Excel
                    </Button>
                  )}

                  {this.state.isShowUnApproveButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.unApproveLogisticReceipt(e)}
                    >
                      UnApprove
                    </Button>
                  )}
                  {this.state.isShowApproveButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.approveLogisticReceipt(e)}
                    >
                      Approve
                    </Button>
                  )}
                  {this.state.isShowCancelButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.cancelLogisticReceipt(e)}
                    >
                      Cancel
                    </Button>
                  )}
                  {this.state.isShowCreateInvoiceButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.createInvoice(e)}
                    >
                      Invoice
                    </Button>
                  )}
                </>
              }
            />
          )}
        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedModuleKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={this.state.moduleOrderStatus}
          />
        )}

        {!this.state.isShowNodes &&
          !this.state.isLogisticReceiptListFormOpen &&
          this.state.isLogisticReceiptEntryFormOpen &&
          !this.state.isLogisticReceiptHistoryFormOpen &&
          !this.state.isLogisticReceiptInvoiceFormOpen &&
          !this.state.isLogisticReceiptImageFormOpen &&
          !this.state.isLogisticReceiptDocumentFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isLogisticReceiptListFormOpen &&
          this.state.isLogisticReceiptEntryFormOpen &&
          !this.state.isLogisticReceiptHistoryFormOpen &&
          !this.state.isLogisticReceiptInvoiceFormOpen &&
          !this.state.isLogisticReceiptImageFormOpen &&
          !this.state.isLogisticReceiptDocumentFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isLogisticReceiptListFormOpen &&
          !this.state.isLogisticReceiptEntryFormOpen &&
          this.state.isLogisticReceiptHistoryFormOpen &&
          !this.state.isLogisticReceiptInvoiceFormOpen &&
          !this.state.isLogisticReceiptImageFormOpen &&
          !this.state.isLogisticReceiptDocumentFormOpen &&
          this.getHistoryView()}
        {this.state.isShowNodes &&
          !this.state.isLogisticReceiptListFormOpen &&
          !this.state.isLogisticReceiptEntryFormOpen &&
          !this.state.isLogisticReceiptHistoryFormOpen &&
          this.state.isLogisticReceiptInvoiceFormOpen &&
          !this.state.isLogisticReceiptImageFormOpen &&
          !this.state.isLogisticReceiptDocumentFormOpen &&
          this.getInvoiceView()}

        {this.state.isShowNodes &&
          !this.state.isLogisticReceiptListFormOpen &&
          !this.state.isLogisticReceiptEntryFormOpen &&
          !this.state.isLogisticReceiptHistoryFormOpen &&
          !this.state.isLogisticReceiptInvoiceFormOpen &&
          this.state.isLogisticReceiptImageFormOpen &&
          !this.state.isLogisticReceiptDocumentFormOpen &&
          this.getImageView()}
        {this.state.isShowNodes &&
          !this.state.isLogisticReceiptListFormOpen &&
          !this.state.isLogisticReceiptEntryFormOpen &&
          !this.state.isLogisticReceiptHistoryFormOpen &&
          !this.state.isLogisticReceiptInvoiceFormOpen &&
          !this.state.isLogisticReceiptImageFormOpen &&
          this.state.isLogisticReceiptDocumentFormOpen &&
          this.getDocumentView()}
        {this.state.isLogisticReceiptListFormOpen &&
          this.state.isSpecialViewMode == false && (
            <LogisticReceiptListForm
              {...this.state}
              editLogisticReceipt={this.editLogisticReceipt}
              filterLogisticReceipt={this.filterLogisticReceipt}
              resetLogisticReceipt={this.resetLogisticReceipt}
              loadFirst={this.loadFirst}
              loadNext={this.loadNext}
              loadPrevious={this.loadPrevious}
              loadLast={this.loadLast}
              handleSortingChange={this.handleSortingChange}
              criteriaOnChange={this.criteriaOnChange}
            />
          )}

        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowLinePopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl1}
          title={"LINE DETAIL"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl1}
              hideAlertCallBack={this.hideAlertCallBackLvl1}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons"
                size="sm"
                onClick={(e) => this.addOrUpdateLine(e)}
                disabled={this.state.isDisabledFields}
              >
                Add/Update
              </Button>
            </div>
          }
          content={
            <div>
              <LogisticReceiptLinePopUpForm
                {...this.state}
                addNewRollLine={this.addNewRollLine}
                getReceiptRollLineData={this.getReceiptRollLineData}
                deleteReceiptRollLine={this.deleteReceiptRollLine}
                onLineChange={this.onLineChange}
                uploadExcelFile={this.uploadExcelFile}
                onFilterChange={this.onFilterChange}
                filterRollLinenClick={this.filterRollLinenClick}
                resetReceiptRollLines={this.resetReceiptRollLines}
              />
            </div>
          }
        />

        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowRollLinePopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel5"}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl5}
          title={"Roll LINE DETAIL"}
          lockScroll={false}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl5}
              hideAlertCallBack={this.hideAlertCallBackLvl5}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons"
                size="sm"
                onClick={(e) => this.addOrUpdateRollLine(e)}
                disabled={this.state.isDisabledFields}
              >
                Add/Update
              </Button>

              <Button
                className="header_buttons"
                size="sm"
                onClick={(e) => this.clearRollLineData(e, true)}
                disabled={this.state.isDisabledFields}
              >
                clear
              </Button>
            </div>
          }
          content={
            <div>
              <LogisticReceiptRollLinePopUpForm
                {...this.state}
                onRollLineChange={this.onRollLineChange}
                onRollLineLocationChange={this.onRollLineLocationChange}
                rollLinelocationEnterKeyEventHandler={
                  this.rollLinelocationEnterKeyEventHandler
                }
                displayAutoCompleteRollLineLocationList={
                  this.displayAutoCompleteRollLineLocationList
                }
              />
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowCreateInvoicePopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel2"}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl2}
          title={"SERVICE DETAILS ENTRY"}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowPopupAlertlvl2}
              hideAlertCallBack={this.hideAlertCallBacklvl2}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons"
                size="sm"
                onClick={(e) => this.createInvoiceFromReceipt(e)}
              >
                Continue
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col className="align-items-left" sm="2">
                  {" "}
                  <FormLabel>CompanyCode</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="companyCode"
                    readOnly={true}
                    value={logisticReceiptData.companyCode}
                    disabled={true}
                  />{" "}
                </Col>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>Receipt#</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="code"
                    readOnly={true}
                    value={logisticReceiptData.code}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col className="align-items-left" sm="2">
                  <FormLabel>Service Details</FormLabel>
                </Col>
              </Row>
              <div className="div_Custom_1">
                <Table id="fabrics_tables_default">
                  <thead>
                    <tr>
                      <th>Line#</th>
                      <th>Service</th>
                      <th>Description</th>
                      <th>Uom</th>
                      <th>Qty</th>
                      <th>Price</th>
                      <th>Amount</th>
                      <th></th>
                    </tr>
                  </thead>
                  {invoiceServiceLineList != null ? (
                    <tbody>
                      {invoiceServiceLineList.map((ln, index) => (
                        <tr key={index}>
                          <td className="hyperLinkText">
                            <Button
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.editService(e, ln.lineNumber, ln)
                              }
                            >
                              {ln.lineNumber}
                            </Button>
                          </td>
                          <td>{ln.serviceCode}</td>
                          <td>{ln.serviceName}</td>
                          <td>{ln.uomCode}</td>
                          <td>{ln.quantity}</td>
                          <td>{ln.unitPrice}</td>
                          <td>{ln.amount}</td>
                          <td>
                            {!ln.isFetched && (
                              <Button
                                size="sm"
                                onClick={(e) => this.deleteService(e, ln)}
                              >
                                <DeleteIcon />
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : null}
                </Table>
                {invoiceServiceLineList.length != 0 ? null : (
                  <div className="no_Data">{"NO DATA"}</div>
                )}
              </div>
              <Row>
                <Col className="align-items-left" sm="">
                  <FormLabel>Service Line Detail</FormLabel>
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>Ln#</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="lineNumber"
                    type="text"
                    onChange={this.serviceLineOnchange}
                    readOnly={true}
                    value={invoiceServiceLineData.lineNumber}
                    disabled={true}
                  />{" "}
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Service</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.serviceOnChange}
                    placeholder="serviceCode"
                    name="serviceCode"
                    value={invoiceServiceLineData.serviceCode}
                    lookupRequired={true}
                    lookupHandler={this.state.serviceLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.serviceEnterKeyEvent}
                    autoCompleteListData={
                      this.state.servicePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayServiceAutoCompleteList
                    }
                    showAutoCompleteList={
                      this.state.isShowAutoCompleteServiceList
                    }
                    // disabled={this.state.isDisabledFields}
                  />
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="serviceName"
                    type="text"
                    onChange={this.serviceLineOnchange}
                    readOnly={true}
                    value={invoiceServiceLineData.serviceName}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>UOM</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.serviceLineOnchange}
                    // placeholder="uomCode"
                    name="uomCode"
                    value={invoiceServiceLineData.uomCode}
                    // lookupRequired={true}
                    // lookupHandler={this.state.uomLookupHandler}
                    // showCriteriaDialog={true}
                    // enterKeyEventHandler={this.invoiceUomEnterKeyEvent}
                    // autoCompleteListData={
                    //   this.state.invoiceUomPageListForAutoCompleteList
                    // }
                    // enableAutoCompleteTextBox={true}
                    // displayAutoCompleteList={
                    //   this.displayInvoiceUomAutoCompleteList
                    // }
                    // showAutoCompleteList={
                    //   this.state.isShowAutoCompleteInvoiceUomList
                    // }
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Price</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={invoiceServiceLineData.unitPrice}
                    onChange={this.serviceLineOnchange}
                    className=" text-right"
                    decimalScale={2}
                    name={"unitPrice"}
                    // readOnly = {true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Qty</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={invoiceServiceLineData.quantity}
                    onChange={this.serviceLineOnchange}
                    className=" text-right"
                    decimalScale={2}
                    name={"quantity"}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Amount</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={invoiceServiceLineData.amount}
                    onChange={this.serviceLineOnchange}
                    className="summary_input text-right"
                    decimalScale={2}
                    name={"amount"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="text-center">
                  <Button
                    size="sm"
                    id="fabric_Add_Button"
                    className="enterFocus"
                    onClick={(e) => this.addLines(e)}
                  >
                    Add/Update
                  </Button>
                  <Button
                    id="fabric_Add_Button"
                    size="sm1"
                    onClick={(e) => this.clearLines(e)}
                  >
                    Clear
                  </Button>
                </Col>
              </Row>
            </div>
          }
        />
        <ReasonCaptureComponent
          reasons={this.state.unapprovalReasons}
          reasonData={this.state.reasonData}
          title="InBound Receipt UnApprove"
          onChange={this.onUnApproveReasonChange}
          onClick={this.onUnApproveReasonContinue}
          isShowPopup={this.state.isShowUnApproveReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.unApproveReasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.unApproveReasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={
            this.displayAutoCompleteUnApproveReasonList
          }
          showAutoCompleteReasonList={
            this.state.showAutoCompleteUnApproveReasonList
          }
          onReasonDescChange={this.onReasonDescChange}
        />
        <ReasonCaptureComponent
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="InBound Receipt Cancel"
          onChange={this.onReasonChange}
          onClick={this.onCancelReasonContinue}
          isShowPopup={this.state.isShowCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowLogisticOrderModule}
          closeModalCallBack={this.closeLogisticModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricPurchaseHistoryInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowItemInventoryPositionInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowItemCurrentInventoryInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
      </div>
    );
  }
}

class LogisticReceiptLinePopUpForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  uploadExcelFile = (e) => {
    this.props.uploadExcelFile(e);
  };
  onFilterChange = (e) => {
    this.props.onFilterChange(e);
  };
  onExcelClick = (e) => {
    if (e.detail == 1) {
      const input = document.getElementById("file-input");
      if (input) {
        input.click();
      }
    }
  };
  filterRollLinenClick = (e) => {
    this.props.filterRollLinenClick(e);
  };

  resetReceiptRollLines = (e) => {
    this.props.resetReceiptRollLines(e);
  };
  render() {
    let logisticReceiptData = this.props.logisticReceiptData;
    let logisticReceiptLineData = this.props.logisticReceiptLineData;
    let receiptRollLines = new Array();

    let is3PL = this.props.is3PL;
    let logisticReceiptRollLineBeanFilter =
      this.props.logisticReceiptRollLineBeanFilter;

    let isSearchCriteria = this.props.isSearchCriteria;
    let isResetCriteria = this.props.isResetCriteria;
    let isShowFilterList = this.props.isShowFilterList;
    if (!isSearchCriteria) {
      if (!isEmptyArray(this.props.receiptRollLines)) {
        receiptRollLines = this.props.receiptRollLines;
      }
    }
    if (isSearchCriteria == true) {
      if (!isEmptyArray(this.props.filterLogisticReceiptList)) {
        receiptRollLines = this.props.filterLogisticReceiptList;
      }
    }
    return (
      <div className="header_div">
        {" "}
        <div>
          <Row>
            <Col sm="1">
              <FormLabel>Line#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                value={logisticReceiptLineData.lineNumber}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>CompanyCode#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                value={logisticReceiptLineData.companyCode}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Receipt#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox value={logisticReceiptData.code} disabled={true} />
            </Col>
            <Col sm="1">
              <FormLabel>Location#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                value={logisticReceiptData.locationCode}
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>{is3PL ? "Item" : "FabricStyleCode"}</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                value={logisticReceiptLineData.fabricStyleCode}
                disabled={true}
              />
            </Col>
            <Col sm="3">
              <InputTextbox
                value={logisticReceiptLineData.fabricStyleName}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Color</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                value={logisticReceiptLineData.colorCode}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Width</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                value={logisticReceiptLineData.widthCode}
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>OrderQty</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name="logisticOrderQuantity"
                value={logisticReceiptLineData.logisticOrderQuantity}
                className="qty_input text-right summary_input"
                decimalScale={2}
                disabled={true}
                onChange={this.props.onLineChange}
              />
            </Col>
            <Col sm="1">
              <FormLabel>OpenOrder Qty</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name="openOrderQuantity"
                value={logisticReceiptLineData.openOrderQuantity}
                className="qty_input text-right summary_input"
                decimalScale={2}
                disabled={true}
                onChange={this.props.onLineChange}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Total Recd</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name="receivedQuantity"
                value={logisticReceiptLineData.receivedQuantity}
                className="qty_input text-right summary_input"
                decimalScale={2}
                disabled={true}
                onChange={this.props.onLineChange}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Total Rolls</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                value={logisticReceiptLineData.totalRolls}
                className="qty_input text-right summary_input"
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>UOM</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                value={logisticReceiptLineData.uomCode}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>RcdToDT</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name="receivedQuantityToDate"
                value={logisticReceiptLineData.receivedQuantityToDate}
                className="qty_input text-right summary_input"
                decimalScale={2}
                disabled={true}
                onChange={this.props.onLineChange}
              />
            </Col>
            <Col sm="1">
              <FormLabel>uomConversionRate</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name="uomConversionRate"
                value={logisticReceiptLineData.uomConversionRate}
                className="qty_input text-right"
                decimalScale={2}
                disabled={true}
                onChange={this.props.onLineChange}
              />
            </Col>
            <Col sm="1">
              <FormLabel>InventoryUOM</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                value={logisticReceiptLineData.inventoryUomCode}
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>Date Of Manufacturing</FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent_adv
                name="dateOfManufacturing"
                value={logisticReceiptLineData.dateOfManufacturing}
                onChange={this.props.onLineChange}
                disabled={this.props.isDisabledFields}
              />
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>Date Of Expiration</FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent_adv
                name="expirationDate"
                value={logisticReceiptLineData.expirationDate}
                onChange={this.props.onLineChange}
                disabled={this.props.isDisabledFields}
              />
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>Number of Pallets</FormLabel>
            </Col>

            <Col sm="2">
              <NumberFormatInputbox
                value={logisticReceiptLineData.numberOfPallets}
                decimalScale={0}
                name={"numberOfPallets"}
                onChange={this.props.onLineChange}
                disabled={this.props.isDisabledFields}
                className="qty_input text-right summary_input"
              />
            </Col>
          </Row>
          <div>
            <Row>
              <Col sm="2">
                <FormLabel> Received Line Rolls</FormLabel>
              </Col>
              <Col sm="2">
                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={(e) => this.onExcelClick(e)}
                  disabled={this.props.isDisabledFields}
                >
                  Load From Excel
                </Button>
                <input
                  type="file"
                  id="file-input"
                  style={{ display: "none" }}
                  onChange={this.uploadExcelFile}
                  accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
                />
              </Col>
              <Col sm="2">
                <Button
                  className="header_buttons"
                  onClick={(e) => this.props.addNewRollLine(e)}
                  disabled={this.props.isDisabledFields}
                >
                  {this.props.is3PL ? "Add Inventory Line" : "Add Roll Line"}
                </Button>
              </Col>
            </Row>

            <Row>
              <Col sm="2">
                <FormLabel>Select Criteria</FormLabel>
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>Serial</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onFilterChange}
                  name="customerLotNumber"
                  value={logisticReceiptRollLineBeanFilter.customerLotNumber}
                  isMandatory={true}
                ></InputTextbox>
              </Col>

              <Col sm="1">
                <FormLabel>UPC#</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onFilterChange}
                  name="upcNumber"
                  value={logisticReceiptRollLineBeanFilter.upcNumber}
                  isMandatory={true}
                ></InputTextbox>
              </Col>

              <Col sm="1">
                <FormLabel>ReceivedQty</FormLabel>
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  name={"receivedQuantity"}
                  onChange={this.onFilterChange}
                  value={logisticReceiptRollLineBeanFilter.receivedQuantity}
                  className="text-right"
                  decimalScale={2}
                  isMandatory={true}
                ></NumberFormatInputbox>
              </Col>
            </Row>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* {this.state.isAllocatedSearchCriteria && ( */}
            <Button
              className=""
              id="fabric_Add_Button"
              size="sm"
              onClick={(e) => this.filterRollLinenClick(e)}
              disabled={isSearchCriteria}
            >
              Filter
            </Button>
            {/* // )} */}

            {/* {this.state.isAllocatedResetCriteria && ( */}
            <Button
              className=""
              id="fabric_Add_Button"
              size="sm"
              onClick={(e) => this.resetReceiptRollLines(e)}
              disabled={isResetCriteria}
            >
              Reset
            </Button>
            {/* )} */}
          </div>

          <div className="div_Custom_2">
            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th>Line#</th>
                  <th>Location#</th>
                  {/* <th>Roll#</th> */}
                  <th>{this.props.is3PL ? "Inventory#" : "RollSKU#"}</th>
                  <th>ReceivedQty</th>
                  {/* <th>CUSTOMER LOT#</th> */}
                  <th className="upc-width">UPC#</th>
                  <th>Project#</th>
                  <th>IMEI#</th>
                  <th>InvRcdQty#</th>
                  <th>Pallet#</th>
                  <th>Bin Location#</th>
                  <th className="">Serial#</th>
                  <th></th>
                </tr>
              </thead>
              {receiptRollLines != null ? (
                <tbody>
                  {receiptRollLines.map((roll, index) => (
                    <tr key={index}>
                      <td className="hyperLinkText">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.props.getReceiptRollLineData(
                              e,
                              roll.logisticRollLineNumber,
                              roll
                            )
                          }
                        >
                          {roll.logisticRollLineNumber}
                        </Button>
                      </td>
                      <td>{roll.locationCode}</td>
                      {/* <td>{roll.rollNumber}</td> */}
                      <td>{roll.rollSkuNumber}</td>
                      <td>{roll.receivedQuantity}</td>
                      <td>{roll.upcNumber}</td>
                      <td>{roll.projectNumber}</td>
                      <td>{roll.imeiNumber}</td>
                      <td>{roll.inventoryReceivedQuantity}</td>
                      <td>{roll.palletNumber}</td>
                      <td>{roll.aisleInfoText}</td>
                      <td>{roll.customerLotNumber}</td>
                      <td>
                        {!roll.isFetched ? (
                          <Button
                            size="sm"
                            onClick={(e) =>
                              this.props.deleteReceiptRollLine(e, roll)
                            }
                            disabled={this.props.isDisabledFields}
                          >
                            <DeleteIcon />
                          </Button>
                        ) : null}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : null}
            </Table>
            {receiptRollLines.length != 0 ? null : (
              <div className="no_Data">{"NO DATA"}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
class LogisticReceiptRollLinePopUpForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      warehouseLookupHandler: null,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.props.wareHouses,
      "Warehouse"
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
  };

  render() {
    const logisticReceiptRollLineData = this.props.logisticReceiptRollLineData;

    const logisticReceiptData = this.props.logisticReceiptData;
    let isProjectDisabled = false;
    if (!isEmptyString(logisticReceiptData.projectNumber)) {
      isProjectDisabled = true;
    }

    return (
      <div>
        <Row>
          <Col sm="2">
            <FormLabel>Line#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              value={logisticReceiptRollLineData.logisticRollLineNumber}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Received Qty</FormLabel>
          </Col>
          <Col sm="4">
            <NumberFormatInputbox
              name={"receivedQuantity"}
              onChange={this.props.onRollLineChange}
              placeholder="Enter receivedQuantity"
              value={logisticReceiptRollLineData.receivedQuantity}
              className="text-right"
              decimalScale={2}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>Location#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              onChange={this.props.onRollLineLocationChange}
              placeholder="LocationCode"
              name="locationCode"
              value={logisticReceiptRollLineData.locationCode}
              lookupRequired={true}
              lookupHandler={this.state.warehouseLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={
                this.props.rollLinelocationEnterKeyEventHandler
              }
              autoCompleteListData={
                this.props.rollLinelocationPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.props.displayAutoCompleteRollLineLocationList
              }
              showAutoCompleteList={
                this.props.isShowAutoCompleteRollLineLocationList
              }
              // readOnly={disableFormFields}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>UPC#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="upcNumber"
              type="text"
              placeholder="enter UPC"
              value={logisticReceiptRollLineData.upcNumber}
              disabled={this.props.isDisabledFields}
              onChange={this.props.onRollLineChange}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>IMEI#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="imeiNumber"
              type="text"
              placeholder="Enter imeiNumber"
              value={logisticReceiptRollLineData.imeiNumber}
              disabled={this.props.isDisabledFields}
              onChange={this.props.onRollLineChange}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Serial#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="customerLotNumber"
              type="text"
              placeholder="Enter CUSTOMER LOT "
              value={logisticReceiptRollLineData.customerLotNumber}
              disabled={this.props.isDisabledFields}
              onChange={this.props.onRollLineChange}
              isMandatory={true}
            />
          </Col>
          {/* <Col sm="2">
            <FormLabel>Roll#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="rollNumber"
              type="text"
              placeholder="Enter rollNumber"
              value={logisticReceiptRollLineData.rollNumber}
              onChange={this.props.onRollLineChange}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />
          </Col> */}
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>
              {this.props.is3PL ? "Inventory#" : "RollSKU#"}
            </FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              value={logisticReceiptRollLineData.rollSkuNumber}
              disabled={true}
            />
          </Col>

          <Col sm="2">
            <FormLabel>ProjectNumber</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="projectNumber"
              type="text"
              value={logisticReceiptRollLineData.projectNumber}
              onChange={this.props.onRollLineChange}
              disabled={isProjectDisabled}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>InvUOM</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="inventoryUomCode"
              type="text"
              value={logisticReceiptRollLineData.inventoryUomCode}
              onChange={this.props.onRollLineChange}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Inv Rcd Qty</FormLabel>
          </Col>
          <Col sm="4">
            <NumberFormatInputbox
              name={"inventoryReceivedQuantity"}
              onChange={this.props.onRollLineChange}
              placeholder="Enter inventoryReceivedQuantity"
              value={logisticReceiptRollLineData.inventoryReceivedQuantity}
              className="qty_input text-right summary_input"
              decimalScale={2}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>Pallet</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="palletNumber"
              type="text"
              placeholder="Enter palletNumber"
              value={logisticReceiptRollLineData.palletNumber}
              onChange={this.props.onRollLineChange}
              disabled={this.props.isDisabledFields}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Bin Loc#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="aisleInfoText"
              type="text"
              placeholder="Enter aisleInfoText"
              value={logisticReceiptRollLineData.aisleInfoText}
              onChange={this.props.onRollLineChange}
              disabled={this.props.isDisabledFields}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
class LogisticReceiptListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {}

  criteriaOnChange = (e) => {
    this.props.criteriaOnChange(e);
  };
  editLogisticReceipt = (e, val) => {
    if (e.detail == 1) this.props.editLogisticReceipt(val);
  };
  filterLogisticReceipt = (e) => {
    if (e.detail == 1) this.props.filterLogisticReceipt();
  };
  resetLogisticReceipt = (e) => {
    if (e.detail == 1) this.props.resetLogisticReceipt();
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterLogisticReceipt();
    }
  };
  render() {
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;

    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;

    let isLoading = this.props.isLoading;
    const logisticReceipt_list = this.props.logisticReceipt_list;
    return (
      <div>
        <div className="secondary_module_header">
          {/* <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                placeholder="Enter Value to Filter.."
                onChange={this.criteriaOnChange}
                onKeyDown={this.onKeyDown}
                value={criteria.searchName}
                name="searchName"
              />
              <span className="px-2"></span>
              <Button onClick={(e) => this.filterLogisticReceipt(e)}>
                Filter
              </Button>
              <span className="px-2"></span>
              <Button onClick={(e) => this.resetLogisticReceipt(e)}>
                Reset
              </Button>
            </span>
          </div> */}
          <div className="mdle-criteria-wrap">
            <div className="">
              <FormLabel className="criteria-labl">Status</FormLabel>
            </div>
            <div className="criteria-val">
              <FormControl
                as="select"
                custom
                onChange={this.criteriaOnChange}
                name="receiptStatus"
                value={criteria.receiptStatus}
              >
                <option value={""}>All</option>
                <option value={"A"}>Approved</option>
                <option value={"U"}>UnApproved</option>
                <option value={"X"}>Cancelled</option>
              </FormControl>
            </div>
            <div className="">
              <FormLabel className="criteria-labl">Search</FormLabel>
            </div>
            <div className="criteria-val">
              <InputTextbox
                placeholder="Enter Value to Filter.."
                onChange={this.criteriaOnChange}
                onKeyDown={this.onKeyDown}
                value={criteria.searchName}
                name="searchName"
              />
            </div>
            <div className="criteria-btn-wrap ">
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.filterLogisticReceipt(e)}
              >
                Filter
              </Button>
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.resetLogisticReceipt(e)}
              >
                Reset
              </Button>
            </div>
            <div className=""> </div>
          </div>
          <div className="module_header_secondary_buttons">
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Receipt Number
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "logisticOrderNumber")
                  }
                >
                  Order Number
                  {this.props.order === "desc" &&
                  this.props.sortField === "logisticOrderNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "customerCode")}
                >
                  customer
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "customerName")}
                >
                  Customer Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerName" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "receiptDate")}>
                  Receipt Date
                  {this.props.order === "desc" &&
                  this.props.sortField === "receiptDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "containerNumber")
                  }
                >
                  Container
                  {this.props.order === "desc" &&
                  this.props.sortField === "containerNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "billOfLading")}
                >
                  BillOfLading
                  {this.props.order === "desc" &&
                  this.props.sortField === "billOfLading" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "customerReferenceNumber")
                  }
                >
                  Reference#
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerReferenceNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "receiptStatus")}
                >
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "receiptStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>

            <tbody>
              {logisticReceipt_list.map((ln, i) => (
                <tr key={i}>
                  <td>
                    <Button
                      size="sm"
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.editLogisticReceipt(e, ln.code)}
                    >
                      {ln.code}
                    </Button>
                  </td>
                  <td>{ln.logisticOrderNumber}</td>
                  <td>{ln.customerCode}</td>
                  <td>{ln.customerName}</td>
                  <td>{ModuleUtils.getDateFormat_v1(ln.receiptDate)}</td>
                  <td>{ln.containerNumber}</td>
                  <td>{ln.billOfLading}</td>
                  <td>{ln.customerReferenceNumber}</td>
                  <td>
                    {ModuleUtils.getLogisticOrderReceiptStatusCaption(
                      ln.receiptStatus
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

class LogisticReceiptEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setFocus();
  }
  setFocus = () => {
    //
  };
  initLookupHandlers = () => {
    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.props.wareHouses,
      "Warehouse"
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
    let logisticOrderLookupHandler = new LogisticOrderLookupHandler(
      this.companyCode,
      "InBound Order",
      // "",
      [
        LogicConstants.LOGISTIC_ORDER_APPROVE_STATUS,
        LogicConstants.LOGISTIC_ORDER_PARTIALLY_RECEIVED_STATUS,
      ]
    );
    this.setState({ logisticOrderLookupHandler: logisticOrderLookupHandler });
  };

  render() {
    let logisticReceiptData = this.props.logisticReceiptData;
    let lines = new Array();
    if (
      !isEmpty(logisticReceiptData) &&
      !isEmptyArray(logisticReceiptData.lines)
    ) {
      lines = logisticReceiptData.lines;
    }
    let is3PL = this.props.is3PL;
    return (
      <div className="header_div">
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Date#</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="createdDate"
              value={logisticReceiptData.createdDate}
              onChange={this.props.onChange}
              disabled={this.props.disableUpdatableFields}
              //Og disabled={true}
            />
          </Col>
          <Col className="so-align-items-left" sm="1">
            {" "}
            <FormLabel
              className="hyperlinklabel"
              onClick={(e) =>
                this.props.lnkLogisticOrderModule(
                  e,
                  logisticReceiptData.logisticOrderNumber
                )
              }
            >
              InBound Order
            </FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              onChange={this.props.onLogisticOrderChange}
              name="logisticOrderNumber"
              placeholder="inBound Order Number"
              value={logisticReceiptData.logisticOrderNumber}
              lookupRequired={true}
              lookupHandler={this.state.logisticOrderLookupHandler}
              enterKeyEventHandler={
                this.props.logisticOrderEnterKeyEventHandler
              }
              autoCompleteListData={
                this.props.logisticOrderPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.props.displayAutoCompleteLogisticOrderList
              }
              showAutoCompleteList={
                this.props.isShowAutoCompleteLogisticOrderList
              }
              isMandatory={true}
              disabled={this.props.isDisabledFields}
            ></InputTextbox>
          </Col>
          <Col sm="1">
            <FormLabel>Customer</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="customerCode"
              type="text"
              value={logisticReceiptData.customerCode}
              disabled={true}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              name="customerName"
              type="text"
              value={logisticReceiptData.customerName}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Location#</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.props.onLocationChange}
              name="locationCode"
              placeholder="locationCode"
              value={logisticReceiptData.locationCode}
              lookupRequired={true}
              lookupHandler={this.state.warehouseLookupHandler}
              enterKeyEventHandler={this.props.locationEnterKeyEventHandler}
              autoCompleteListData={
                this.props.locationPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.props.displayAutoCompleteLocationList
              }
              showAutoCompleteList={this.props.isShowAutoCompleteLocationList}
              disabled={true}
              // isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>ReceiptDate</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="receiptDate"
              value={logisticReceiptData.receiptDate}
              onChange={this.props.onChange}
              disabled={this.props.disableUpdatableFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Container#</FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="containerNumber"
              type="text"
              value={logisticReceiptData.containerNumber}
              onChange={this.props.onChange}
              disabled={this.props.disableUpdatableFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>BillOfLading#</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="billOfLading"
              type="text"
              placeholder="Enter billOfLading"
              value={logisticReceiptData.billOfLading}
              onChange={this.props.onChange}
              disabled={this.props.disableUpdatableFields}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Ref#</FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="customerReferenceNumber"
              type="text"
              value={logisticReceiptData.customerReferenceNumber}
              onChange={this.props.onChange}
              disabled={this.props.disableUpdatableFields}
            />
          </Col>
          <Col className="align-items-left" sm="1">
            <FormLabel>Date Of Manufacturing</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="dateOfManufacturing"
              value={logisticReceiptData.dateOfManufacturing}
              onChange={this.props.onChange}
              disabled={this.props.disableUpdatableFields}
            />
          </Col>
          <Col className="align-items-left" sm="1">
            <FormLabel>Date Of Expiration</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="expirationDate"
              value={logisticReceiptData.expirationDate}
              onChange={this.props.onChange}
              disabled={this.props.disableUpdatableFields}
            />
          </Col>

          <Col className="align-items-left" sm="1">
            <FormLabel>Total no.of pallets</FormLabel>
          </Col>

          <Col sm="2">
            <NumberFormatInputbox
              value={logisticReceiptData.totalNumberOfPallets}
              onChange={this.props.onChange}
              // className="text-right"
              decimalScale={0}
              name={"totalNumberOfPallets"}
              // disabled={this.props.isDisabledFields}
              disabled={this.props.disableUpdatableFields}
              className="qty_input text-right summary_input"
            />
          </Col>

          <Col className="align-items-left" sm="1">
            <FormLabel>WareHouse Po </FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="warehousePurchaseOrderNumber"
              onChange={this.props.onChange}
              value={logisticReceiptData.warehousePurchaseOrderNumber}
              disabled={this.props.disableUpdatableFields}
            />{" "}
          </Col>

          <Col className="align-items-left" sm="1">
            <FormLabel>ProjectNumber </FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="projectNumber"
              onChange={this.props.onChange}
              value={logisticReceiptData.projectNumber}
              disabled={this.props.disableUpdatableFields}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <Button
              className="hyperLinkText"
              variant="secondry"
              onClick={(e) => this.props.openDocPopup(e)}
            >
              Documents
            </Button>
          </Col>
          <Col sm="1">
            <Button
              className="hyperLinkText"
              variant="secondry"
              onClick={(e) => this.props.openImagePopup(e)}
            >
              Images
            </Button>
          </Col>

          <Col sm="4">
            <Images
              logisticReceiptData={this.props.logisticReceiptData}
              mainImageUrl={this.props.mainImageUrl}
              webImageUrl={this.props.webImageUrl}
              frontImageUrl={this.props.frontImageUrl}
              backImageUrl={this.props.backImageUrl}
              openItemImage={this.props.openItemImage}
            />
          </Col>
        </Row>

        <div className="div_default">
          <div>
            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th></th>
                  <th>Line#</th>
                  <th>{is3PL ? "Item#" : "FabricStyle#"}</th>
                  <th>{is3PL ? "ItemName" : "FabricStyleName"}</th>
                  <th>Color#</th>
                  <th>UOM#</th>
                  <th>OrdQty</th>
                  <th>opnOrderQty</th>
                  <th>RcdToDT</th>
                  <th>ReceivedQty</th>
                  <th>Status</th>
                  {/* <th></th> */}
                </tr>
              </thead>
              {lines != null ? (
                <tbody>
                  {lines.map((ln, index) => (
                    <tr key={index}>
                      <td>
                        <ShortCutMenuPopup
                          value={ln.fabricStyleCode}
                          // popupData = {this.state.tempPopUpData }
                          menuItems={
                            <ul>
                              <li
                                className="shortcut-menu-item"
                                onClick={(e) =>
                                  this.props.lnkFabricModule(
                                    e,
                                    ln.fabricStyleCode
                                  )
                                }
                              >
                                {" "}
                                Item Info{" "}
                              </li>

                              <li
                                className="shortcut-menu-item"
                                onClick={(e) =>
                                  this.props.openItemPurchaseHistoryInq(
                                    e,
                                    ln.fabricStyleCode
                                  )
                                }
                              >
                                {" "}
                                Vendor-Item Purchase History{""}
                              </li>

                              <li
                                className="shortcut-menu-item"
                                onClick={(e) =>
                                  this.props.openItemCurrentInvInq(
                                    e,
                                    ln.fabricStyleCode
                                  )
                                }
                              >
                                {" "}
                                Item Current Inventory Level{""}
                              </li>

                              <li
                                className="shortcut-menu-item"
                                onClick={(e) =>
                                  this.props.openItemInvPositionInq(
                                    e,
                                    ln.fabricStyleCode
                                  )
                                }
                              >
                                {" "}
                                Item Inventory Position{""}
                              </li>
                            </ul>
                          }
                        />
                      </td>
                      <td className="hyperLinkText">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.props.getLogisticReceiptLine(e, ln)
                          }
                        >
                          {ln.lineNumber}
                        </Button>
                      </td>
                      <td>{ln.fabricStyleCode}</td>
                      <td>{ln.fabricStyleName}</td>
                      <td>{ln.colorCode}</td>
                      <td>{ln.uomCode}</td>
                      <td className="text-right">{ln.logisticOrderQuantity}</td>
                      <td className="text-right">{ln.openOrderQuantity}</td>
                      <td className="text-right">
                        {ln.receivedQuantityToDate}
                      </td>
                      <td className="text-right">{ln.receivedQuantity}</td>
                      <td>
                        {ModuleUtils.getLogisticOrderReceiptLineStatusCaption(
                          ln.lineStatus
                        )}
                      </td>
                      {/* <td>
                        {ln.lineStatus !=
                          LogicConstants.LOGISTIC_ORDER_RECEIPT_LINE_CANCEL_STATUS && (
                          <Button
                            size="sm"
                            onClick={() =>
                              this.deleteReceiptLine(ln.lineNumber, ln)
                            }
                          >
                            <DeleteIcon />
                          </Button>
                        )}
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              ) : null}
            </Table>
            {lines.length != 0 ? null : (
              <div className="no_Data">{"NO DATA"}</div>
            )}
          </div>
        </div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.props.isShowItemImagePopup}
          closeAlertModalCallBack={this.props.closeAlertModalCallBackLvl1}
          title={"Item Images"}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowAlertLvl1}
              hideAlertCallBack={this.props.hideAlertCallBackLvl1}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              {/* {isDisableaddOrUpdate ? null : (
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.props.addorUpdateImageData(e)}
                  disabled={isDisabledFields}
                >
                  Add/Update
                </Button>
              )} */}
            </div>
          }
          content={<ItemImagePopup {...this.props} />}
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel5"}
          isModulePopup={false}
          isShowPopup={this.props.isShowItemDocPopup}
          closeAlertModalCallBack={this.props.closeAlertModalCallBackLvl5}
          title={"Item Documents"}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowAlertLvl5}
              hideAlertCallBack={this.props.hideAlertCallBackLvl5}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              {/* <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.props.addorUpdateDocData(e)}
                disabled={isDisabledFields}
              >
                Add/Update
              </Button> */}
            </div>
          }
          content={<ItemDocPopup {...this.props} />}
        />
      </div>
    );
  }
}
class LogisticReceiptHistoryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {
    //
  }
  render() {
    let logisticReceiptData = this.props.logisticReceiptData;
    let statusTracks = logisticReceiptData.statusTracks;
    if (!statusTracks) {
      statusTracks = new Array();
    }
    let changeHistoryTracks = logisticReceiptData.changeHistoryTracks;
    if (!changeHistoryTracks) {
      changeHistoryTracks = new Array();
    }
    return (
      <div className="header_div">
        <div className="div_inline">
          {" "}
          <div class="div_Equal">
            <FormLabel>Status History</FormLabel>
            <Table id="fabrics_tables_default">
              <thead>
                <th>Date</th>
                <th>Status</th>
                <th>Previous Status</th>
                <th>Done By</th>
                <th>Remarks</th>
              </thead>
              <tbody>
                {statusTracks.map((list, index) => (
                  <tr key={index}>
                    <td className="">{list.createdDate}</td>
                    <td className="">
                      {ModuleUtils.getLogisticOrderReceiptStatusCaption(
                        list.currentStatus
                      )}
                    </td>
                    <td className="">
                      {ModuleUtils.getLogisticOrderReceiptStatusCaption(
                        list.previousStatus
                      )}
                    </td>
                    <td className="">{list.createdBy}</td>
                    <td className="">{list.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {statusTracks.length != 0 ? null : (
              <div className="no_Data_small">{"NO DATA"}</div>
            )}
          </div>
          <div class="div_Equal">
            <FormLabel>Header Change History</FormLabel>
            <Table id="fabrics_tables_default">
              <thead>
                <th>Field</th>
                <th>Original Value</th>
                <th>Changed Value</th>
                <th>Changed By</th>
                <th>Changed On</th>
                <th>Remarks</th>
              </thead>
              <tbody>
                {changeHistoryTracks.map((list, index) => (
                  <tr key={index}>
                    <td className="">{list.updatedDate}</td>
                    <td className="">{list.updatedby}</td>
                    <td className="">{list.description}</td>
                    <td className="">{list.description}</td>
                    <td className="">{list.description}</td>
                    <td className="">{list.description}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {changeHistoryTracks.length != 0 ? null : (
              <div className="no_Data_small">{"NO DATA"}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

class LogisticReceiptInvoiceForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      isShowInvoiceModule: false,
      moduleForPopup: [],
    };
  }

  /** Invoice */
  invoiceHandleHyperLinkClick = (e, val, rowData) => {
    if (e.detail == 1) {
      if (val !== "" && val !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={val}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  closeModalCallBack = (isOpen) => {
    this.setState({ isShowInvoiceModule: isOpen, moduleForPopup: [] });
  };

  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };

  //#endregion

  render() {
    return (
      <div className="header_div">
        <Row>
          <Col sm="1" className="title_text_div">
            {" "}
            <FormLabel>Invoice</FormLabel>{" "}
          </Col>
        </Row>
        <Table id="fabrics_tables_default">
          <thead>
            <th>Invoice#</th>
            <th>Date</th>
            <th>Status</th>
          </thead>
          <tbody>
            {this.props.invList.map((list, index) => (
              <tr key={index}>
                <td>
                  <Button
                    size="sm"
                    variant="secondry"
                    className="hyperLinkText"
                    onClick={(e) =>
                      this.invoiceHandleHyperLinkClick(e, list.code)
                    }
                  >
                    {list.code}
                  </Button>
                </td>
                <td>{list.createdDate}</td>
                <td className="text-right">
                  {ModuleUtils.getInvoiceStatusCaption(list.invoiceStatus)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {this.props.invList.length != 0 ? null : (
          <div className="no_Data_small">{"NO DATA"}</div>
        )}

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
      </div>
    );
  }
}

export function ItemDocPopup(props) {
  const [doc1, setDoc1] = useState(null);
  const [doc1Name, setDoc1Name] = useState(props.doc1Name);
  const [doc1Url, setDoc1Url] = useState(props.doc1Url);

  const [doc2, setDoc2] = useState(null);
  const [doc2Name, setDoc2Name] = useState(props.doc2Name);
  const [doc2Url, setDoc2Url] = useState(props.doc2Url);

  const [doc3, setDoc3] = useState(null);
  const [doc3Name, setDoc3Name] = useState(props.doc3Name);
  const [doc3Url, setDoc3Url] = useState(props.doc3Url);

  const [doc4, setDoc4] = useState(null);
  const [doc4Name, setDoc4Name] = useState(props.doc4Name);
  const [doc4Url, setDoc4Url] = useState(props.doc4Url);

  useEffect(() => {
    setDoc1Name(props.doc1Name);
  }, [props.doc1Name]);
  useEffect(() => {
    setDoc2Name(props.doc2Name);
  }, [props.doc2Name]);
  useEffect(() => {
    setDoc3Name(props.doc3Name);
  }, [props.doc3Name]);
  useEffect(() => {
    setDoc4Name(props.doc4Name);
  }, [props.doc4Name]);

  useEffect(() => {
    setDoc1Url(props.doc1Url);
  }, [props.doc1Url]);
  useEffect(() => {
    setDoc2Url(props.doc2Url);
  }, [props.doc2Url]);
  useEffect(() => {
    setDoc3Url(props.doc3Url);
  }, [props.doc3Url]);
  useEffect(() => {
    setDoc4Url(props.doc4Url);
  }, [props.doc4Url]);

  const handleSubmit = (e, type) => {
    e.preventDefault();
    // if (e.detail == 1) {
    if (type == 1) {
      if (doc1) {
        props.uploadDoc(doc1, 1);
        props.setDoc1Url(URL.createObjectURL(doc1));
        props.setDoc1Data(doc1);
        props.setDoc1Name(doc1.name);
        props.showToast("Uploaded Sucessfully", 1, 5);
      }
    } else if (type == 2) {
      if (doc2) {
        props.uploadDoc(doc2, 2);
        props.setDoc2Url(URL.createObjectURL(doc2));
        props.setDoc2Data(doc2);
        props.setDoc2Name(doc2.name);
        props.showToast("Uploaded Sucessfully", 1, 5);
      }
    } else if (type == 3) {
      if (doc3) {
        props.uploadDoc(doc3, 3);
        props.setDoc3Url(URL.createObjectURL(doc3));
        props.setDoc3Data(doc3);
        props.setDoc3Name(doc3.name);
        props.showToast("Uploaded Sucessfully", 1, 5);
      }
    } else if (type == 4) {
      if (doc4) {
        props.uploadDoc(doc4, 4);
        props.setDoc4Url(URL.createObjectURL(doc4));
        props.setDoc4Data(doc4);
        props.setDoc4Name(doc4.name);
        props.showToast("Uploaded Sucessfully", 1, 5);
      }
    }
    // }
  };

  const docViewHandler = (e, type) => {
    if (e.detail == 1) {
      if (type == 1) {
        window.open(doc1Url);
      } else if (type == 2) {
        window.open(doc2Url);
      } else if (type == 3) {
        window.open(doc3Url);
      } else if (type == 4) {
        window.open(doc4Url);
      }
    }
  };

  const handleChange = (e, type) => {
    e.preventDefault();
    if (type == 1) {
      setDoc1(e.target.files[0]);
      setDoc1Name(e.target.files[0].name);
      setDoc1Url(URL.createObjectURL(e.target.files[0]));
    } else if (type == 2) {
      setDoc2(e.target.files[0]);
      setDoc2Name(e.target.files[0].name);
      setDoc2Url(URL.createObjectURL(e.target.files[0]));
    } else if (type == 3) {
      setDoc3(e.target.files[0]);
      setDoc3Name(e.target.files[0].name);
      setDoc3Url(URL.createObjectURL(e.target.files[0]));
    } else if (type == 4) {
      setDoc4(e.target.files[0]);
      setDoc4Name(e.target.files[0].name);
      setDoc4Url(URL.createObjectURL(e.target.files[0]));
    }
  };

  const deleteDoc = (e, type) => {
    if (e.detail == 1) {
      if (type == 1) {
        setDoc1(null);
        setDoc1Name("");
        props.deleteDoc(1);
      } else if (type == 2) {
        setDoc2(null);
        setDoc2Name("");
        props.deleteDoc(2);
      } else if (type == 3) {
        setDoc3(null);
        setDoc3Name("");
        props.deleteDoc(3);
      } else if (type == 4) {
        setDoc4(null);
        setDoc4Name("");
        props.deleteDoc(4);
      }
      props.showToast("Document deleted sucessfully", 1, 5);
    }
  };

  return (
    <div>
      <Row>
        <Col sm="12">
          <form onSubmit={(e) => handleSubmit(e, 1)}>
            <div className="d-flex justify-content-center align-items-center pt-2">
              <FormLabel
                className="hyperlinklabel align-middle"
                onClick={(e) => docViewHandler(e, 1)}
              >
                {doc1Name}
              </FormLabel>
            </div>
            <div className="d-flex justify-content-around align-items-center">
              <div>
                <label
                  for="doc1"
                  className="d-flex justify-content-around align-items-center"
                >
                  <div className="img_label">
                    Attach Document
                    <span className="img_icon">
                      <UploadDocIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="doc1"
                    accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt, image/*"
                    onChange={(e) => handleChange(e, 1)}
                    disabled={props.disableUpdatableFields}
                  />
                </label>
              </div>
              {!isEmptyString(doc1Name) && (
                <div className="d-flex justify-content-around align-middle align-items-center">
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.disableUpdatableFields}
                    >
                      Upload
                    </Button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteDoc(e, 1)}
                      disabled={props.disableUpdatableFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </Col>
        <Col sm="12">
          <form onSubmit={(e) => handleSubmit(e, 2)}>
            <div className="d-flex justify-content-center align-items-center pt-2">
              <FormLabel
                className="hyperlinklabel align-middle"
                onClick={(e) => docViewHandler(e, 2)}
              >
                {doc2Name}
              </FormLabel>
            </div>
            <div className="d-flex justify-content-around align-items-center">
              <div>
                <label
                  for="doc2"
                  className="d-flex justify-content-around align-items-center"
                >
                  <div className="img_label">
                    Attach Document
                    <span className="img_icon">
                      <UploadDocIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="doc2"
                    accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt, image/*"
                    onChange={(e) => handleChange(e, 2)}
                    disabled={props.disableUpdatableFields}
                  />
                </label>
              </div>
              {!isEmptyString(doc2Name) && (
                <div className="d-flex justify-content-around align-middle align-items-center">
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.disableUpdatableFields}
                    >
                      Upload
                    </Button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteDoc(e, 2)}
                      disabled={props.disableUpdatableFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </Col>
        <Col sm="12">
          <form onSubmit={(e) => handleSubmit(e, 3)}>
            <div className="d-flex justify-content-center align-items-center pt-2">
              <FormLabel
                className="hyperlinklabel align-middle"
                onClick={(e) => docViewHandler(e, 3)}
              >
                {doc3Name}
              </FormLabel>
            </div>
            <div className="d-flex justify-content-around align-items-center">
              <div>
                <label
                  for="doc3"
                  className="d-flex justify-content-around align-items-center"
                >
                  <div className="img_label">
                    Attach Document
                    <span className="img_icon">
                      <UploadDocIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="doc3"
                    accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt, image/*"
                    onChange={(e) => handleChange(e, 3)}
                    disabled={props.disableUpdatableFields}
                  />
                </label>
              </div>
              {!isEmptyString(doc3Name) && (
                <div className="d-flex justify-content-around align-middle align-items-center">
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.disableUpdatableFields}
                    >
                      Upload
                    </Button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteDoc(e, 3)}
                      disabled={props.disableUpdatableFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </Col>
        <Col sm="12">
          <form onSubmit={(e) => handleSubmit(e, 4)}>
            <div className="d-flex justify-content-center align-items-center pt-2">
              <FormLabel
                className="hyperlinklabel align-middle"
                onClick={(e) => docViewHandler(e, 4)}
              >
                {doc4Name}
              </FormLabel>
            </div>
            <div className="d-flex justify-content-around align-items-center">
              <div>
                <label
                  for="doc4"
                  className="d-flex justify-content-around align-items-center"
                >
                  <div className="img_label">
                    Attach Document
                    <span className="img_icon">
                      <UploadDocIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="doc4"
                    accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt, image/*"
                    onChange={(e) => handleChange(e, 4)}
                    disabled={props.disableUpdatableFields}
                  />
                </label>
              </div>
              {!isEmptyString(doc4Name) && (
                <div className="d-flex justify-content-around align-middle align-items-center">
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.disableUpdatableFields}
                    >
                      Upload
                    </Button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteDoc(e, 4)}
                      disabled={props.disableUpdatableFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </Col>
      </Row>
    </div>
  );
}

export function ItemImagePopup(props) {
  const [file, setFile] = useState(null);
  const [fileWeb, setFileWeb] = useState(null);
  const [fileFront, setFileFront] = useState(null);
  const [fileBack, setFileBack] = useState(null);

  const [previewMainUrl, setPreviewMainUrl] = useState(props.mainImageUrl);
  const [previewWebUrl, setPreviewWebUrl] = useState(props.webImageUrl);
  const [previewFrontUrl, setPreviewFrontUrl] = useState(props.frontImageUrl);
  const [previewBackUrl, setPreviewBackUrl] = useState(props.backImageUrl);

  const handleChange = (e, imagePart) => {
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    if (e.target.files[0].size <= max_size) {
      if (imagePart === MAIN_IMAGE_PART) {
        setFile(e.target.files[0]);
        setPreviewMainUrl(URL.createObjectURL(e.target.files[0]));
      } else if (imagePart === WEB_IMAGE_PART) {
        setFileWeb(e.target.files[0]);
        setPreviewWebUrl(URL.createObjectURL(e.target.files[0]));
      }
      if (imagePart === FRONT_IMAGE_PART) {
        setFileFront(e.target.files[0]);
        setPreviewFrontUrl(URL.createObjectURL(e.target.files[0]));
      }
      if (imagePart === BACK_IMAGE_PART) {
        setFileBack(e.target.files[0]);
        setPreviewBackUrl(URL.createObjectURL(e.target.files[0]));
      }
    } else {
      props.showToast("image size is greater", 2);
    }
  };

  const handleSubmit = async (e, imagePart) => {
    e.preventDefault();
    if (imagePart === MAIN_IMAGE_PART) {
      if (file != null) {
        props.setMainUrl(URL.createObjectURL(file));
        props.setMainImg(file);
        props.uploadImage(file, MAIN_IMAGE_PART);
        props.showToast("Main image uploaded sucessfully", 1, 1);
      }
    } else if (imagePart === WEB_IMAGE_PART) {
      if (fileWeb != null) {
        props.setWebUrl(URL.createObjectURL(fileWeb));
        props.setWebImg(fileWeb);
        props.uploadImage(fileWeb, WEB_IMAGE_PART);
        props.showToast("Web image uploaded sucessfully", 1, 1);
      }
    } else if (imagePart === FRONT_IMAGE_PART) {
      if (fileFront != null) {
        props.setFrontUrl(URL.createObjectURL(fileFront));
        props.setFrontImg(fileFront);
        props.uploadImage(fileFront, FRONT_IMAGE_PART);
        props.showToast("Front image uploaded sucessfully", 1, 1);
      }
    } else if (imagePart === BACK_IMAGE_PART) {
      if (fileBack != null) {
        props.setBackUrl(URL.createObjectURL(fileBack));
        props.setBackImg(fileBack);
        props.uploadImage(fileBack, BACK_IMAGE_PART);
        props.showToast("Back image uploaded sucessfully", 1, 1);
      }
    }
  };

  const deleteItemImage = (e, imagePart) => {
    if (e.detail == 1) {
      if (imagePart == MAIN_IMAGE_PART) {
        setFile(null);
        setPreviewMainUrl("");
      } else if (imagePart == WEB_IMAGE_PART) {
        setFileWeb(null);
        setPreviewWebUrl("");
      } else if (imagePart == FRONT_IMAGE_PART) {
        setFileFront(null);
        setPreviewFrontUrl("");
      } else if (imagePart == BACK_IMAGE_PART) {
        setFileBack(null);
        setPreviewBackUrl("");
      }

      props.deleteItemImage(imagePart);
      props.showToast("Image Deleted sucessfully", 1, 1);
    }
  };
  return (
    <div className="img-pop">
      <div className="div_inline">
        <div className="div_Equal_no_overflow">
          <form onSubmit={(e) => handleSubmit(e, MAIN_IMAGE_PART)}>
            <div className="d-flex justify-content-around ">
              {/* {previewMainUrl && ( */}
              <img
                className="img_div"
                src={previewMainUrl}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImage;
                }}
                width={275}
                height={275}
                mode="fit"
              />
              {/* )} */}
            </div>
            <div className="d-flex justify-content-around ">
              <div>
                <label
                  for="mainImgData"
                  className="d-flex justify-content-around "
                >
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="mainImgData"
                    accept="image/*"
                    onChange={(e) => handleChange(e, MAIN_IMAGE_PART)}
                    disabled={props.disableUpdatableFields}
                  />
                </label>
              </div>
              {!isEmptyString(previewMainUrl) && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.disableUpdatableFields}
                    >
                      Upload
                    </Button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteItemImage(e, MAIN_IMAGE_PART)}
                      disabled={props.disableUpdatableFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
        <div className="div_Equal_no_overflow">
          <form onSubmit={(e) => handleSubmit(e, WEB_IMAGE_PART)}>
            <div className="d-flex justify-content-around ">
              {/* {previewWebUrl && ( */}
              <img
                className="img_div"
                src={previewWebUrl}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImage;
                }}
                width={275}
                height={275}
                mode="fit"
              />
              {/* )} */}
            </div>
            <div className="d-flex justify-content-around ">
              <div>
                <label
                  for="webImgData"
                  className="d-flex justify-content-around "
                >
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="webImgData"
                    accept="image/*"
                    onChange={(e) => handleChange(e, WEB_IMAGE_PART)}
                    disabled={props.disableUpdatableFields}
                  />
                </label>
              </div>
              {previewWebUrl && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.disableUpdatableFields}
                    >
                      Upload
                    </Button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteItemImage(e, WEB_IMAGE_PART)}
                      disabled={props.disableUpdatableFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
      <div className="div_inline">
        <div className="div_Equal_no_overflow">
          <form onSubmit={(e) => handleSubmit(e, FRONT_IMAGE_PART)}>
            <div className="d-flex justify-content-around ">
              {/* {previewFrontUrl && ( */}
              <img
                className="img_div"
                src={previewFrontUrl}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImage;
                }}
                width={275}
                height={275}
                mode="fit"
              />
              {/* )} */}
            </div>
            <div className="d-flex justify-content-around ">
              <div>
                <label
                  for="frontImgData"
                  className="d-flex justify-content-around "
                >
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="frontImgData"
                    accept="image/*"
                    onChange={(e) => handleChange(e, FRONT_IMAGE_PART)}
                    disabled={props.disableUpdatableFields}
                  />
                </label>
              </div>
              {previewFrontUrl && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle">
                    <button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.disableUpdatableFields}
                    >
                      Upload
                    </button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteItemImage(e, FRONT_IMAGE_PART)}
                      disabled={props.disableUpdatableFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
        <div className="div_Equal_no_overflow">
          <form onSubmit={(e) => handleSubmit(e, BACK_IMAGE_PART)}>
            <div className="d-flex justify-content-around ">
              {/* {previewBackUrl && ( */}
              <img
                className="img_div"
                src={previewBackUrl}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImage;
                }}
                width={275}
                height={275}
                mode="fit"
              />
              {/* )} */}
            </div>
            <div className="d-flex justify-content-around ">
              <div>
                <label for="backImg" className="d-flex justify-content-around ">
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="backImg"
                    accept="image/*"
                    onChange={(e) => handleChange(e, BACK_IMAGE_PART)}
                    disabled={props.disableUpdatableFields}
                  />
                </label>
              </div>
              {previewBackUrl && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle">
                    <button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.disableUpdatableFields}
                    >
                      Upload
                    </button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteItemImage(e, BACK_IMAGE_PART)}
                      disabled={props.disableUpdatableFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export function Images(props) {
  const openItemImage = () => {
    props.openItemImage();
  };

  const [mainImg, setMainImg] = useState(props.mainImageUrl);
  const [WebImg, setWebImg] = useState(props.webImageUrl);
  const [frontImg, setFrontImg] = useState(props.frontImageUrl);
  const [backImg, setBackImg] = useState(props.backImageUrl);

  useEffect(() => {
    setMainImg(props.mainImageUrl);
  }, [props.mainImageUrl]);

  useEffect(() => {
    setWebImg(props.webImageUrl);
  }, [props.webImageUrl]);

  useEffect(() => {
    setFrontImg(props.frontImageUrl);
  }, [props.frontImageUrl]);

  useEffect(() => {
    setBackImg(props.backImageUrl);
  }, [props.backImageUrl]);

  const content = (url) => {
    return (
      <img
        src={url}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        // width={800}
        // height={600}
        // mode="fit"
      />
    );
  };
  return (
    <div>
      <img
        // data-tip={props.mainImageUrl}
        // data-for="global"
        // data-event="click focus"
        src={mainImg}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        width={100}
        height={100}
        mode="fit"
        // onClick={openItemImage}
      />{" "}
      <img
        // data-tip={props.webImageUrl}
        // data-for="global"
        // data-event="click focus"
        src={WebImg}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        width={100}
        height={100}
        mode="fit"
      />
      <img
        // data-tip={props.frontImageUrl}
        // data-for="global"
        // data-event="click focus"
        src={frontImg}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        width={100}
        height={100}
        mode="fit"
      />
      <img
        // data-tip={props.backImageUrl}
        // data-for="global"
        // data-event="click focus"
        src={backImg}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        width={100}
        height={100}
        mode="fit"
      />
      {/* <ReactTooltip
        id="global"
        // aria-haspopup="true"
        className="cstm-img-tool-tip"
        // globalEventOff="click"
        getContent={(dataTip) => content(dataTip)}
        // place='bottom'
      ></ReactTooltip> */}
    </div>
  );
}

export function MutilpleImages(props) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(props.imgUrl);
  const [images, setImages] = useState([...props.images]);
  const [img_Url, setImageUrl] = useState([...props.preview_Url]);
  const [tempIndex, setIndex] = useState(null);
  const [tempImage, setTempImages] = useState([]);
  const [tempImg_Url, setTempImageUrl] = useState([]);
  const [isImagePreview, setIsImagePreview] = useState(false);
  const [isImageMainPreview, setIsImageMainPreview] = useState(false);
  const isShowDocLabel = props.isShowDocLabel;
  const disabledImages = props.isServiceLineDisablesFields;
  const [imgDetails, setTempFile] = useState(null);

  const [hover, setHover] = useState(false);
  const [hoverData, setHoverData] = useState(
    new LogisticOrderReceiptImageBean()
  );
  const [aftUpload, setAftUpload] = useState(false);

  // const invoiceImage = props.logisticOrderData.invoiceImages.length;

  // const imageEntity = props.imageEntity;

  const [imageEntity, setImagesEntity] = useState(
    new LogisticOrderReceiptImageBean()
  );
  useEffect(() => {
    setImagesEntity(imageEntity);
  }, [imageEntity]);
  const handleChange = (e) => {
    let tempImages = e.target.files;
    if (!isEmptyArray(tempImages)) {
      setIsImageMainPreview(true);
    }
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    let img_list = [];
    let previewList = [];
    if (!isEmptyArray(images)) {
      img_list = [...images];
    }
    if (!isEmptyArray(img_Url)) {
      previewList = [...img_Url];
    }
    for (let index = 0; index < tempImages.length; index++) {
      let imgUrl = "";
      if (tempImages[index].size <= max_size) {
        img_list.push(tempImages[index]);
        imgUrl = URL.createObjectURL(tempImages[index]);
        previewList.push(imgUrl);
      } else {
        props.showToast("image size is greater", 2);
      }
    }
    setImages(img_list);
    setImageUrl(previewList);
  };
  useEffect(() => {
    setImageUrl(img_Url);
  }, [img_Url]);

  useEffect(() => {
    setImages(images);
  }, [images]);
  useEffect(() => {
    setIsImageMainPreview(isImageMainPreview);
  }, [isImageMainPreview]);

  const handleImageEditChange = (e) => {
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    let images_temp = [];
    let url_temp = [];
    let imgUrl = "";
    if (e.target.files[0].size <= max_size) {
      images_temp = [...images];
      url_temp = [...img_Url];
      setIsImagePreview(true);
      setIsImageMainPreview(false);
      // })
      for (let i = 0; i < images_temp.length; i++) {
        if (i === tempIndex) {
          let file = e.target.files[0];
          setFile(file);
        }
      }
      for (let i = 0; i < url_temp.length; i++) {
        if (i === tempIndex) {
          imgUrl = URL.createObjectURL(e.target.files[0]);
          url_temp[i] = imgUrl; // Change the value at index 2
        }
      }
    } else {
      props.showToast("image size is greater", 2);
    }
    setPreviewUrl(imgUrl);
    setTempImages(images_temp);
    setTempImageUrl(url_temp);
  };
  useEffect(() => {
    setIsImagePreview(isImagePreview);
  }, [isImagePreview]);
  const handleSubmit = (e) => {
    e.preventDefault();
    props.setMultiImageUrl(img_Url);
    props.setMultiImgData(images);
    props.uploadMutiImage(images);
    props.showToast("Uploaded Sucessfully", 1);
    setIsImageMainPreview(false);
  };
  const handleEditSubmit = (e) => {
    e.preventDefault();
    let tempFile = file;
    for (let i = 0; i < tempImage.length; i++) {
      if (i === tempIndex) {
        tempFile.imageCode = tempImage[i].imageCode;
        tempImage[i] = tempFile;
      }
    }
    props.setMultiImageUrl(tempImg_Url);
    props.setMultiImgData(tempImage);
    props.uploadMutiImage(tempImage);
    setImageUrl(tempImg_Url);
    props.showToast("Uploaded Sucessfully", 1);
    setIndex(null);
    setIsImagePreview(false);
    setPreviewUrl("");
  };

  const deleteImage = (e) => {
    if (e.detail == 1) {
      setFile(null);
      setPreviewUrl("");
      // props.deleteImage();
      props.showToast("Image deleted sucessfully", 1);
      setIsImageMainPreview(false);
      setImages(props.images);
      setImageUrl(props.preview_Url);
    }
  };
  const imageview = (e, index, image) => {
    if (!isImageMainPreview) {
      const files = e.target.currentSrc;
      let imgDetails = null;
      const urls = files;
      setPreviewUrl(urls);
      setIndex(index);
      setIsImagePreview(false);
      // for (let i = 0; i < images.length; i++) {
      //   if (i === index) {
      //     imgDetails = images[i];
      //   }
      // }

      for (let i = 0; i < props.logisticReceiptData.receiptImages.length; i++) {
        if (i === index) {
          imgDetails = props.logisticReceiptData.receiptImages[i];
        }
      }

      setTempFile(imgDetails);

      const updatedImageEntity = {
        ...imgDetails, // Spread the class instance to convert to plain object
        tags: imgDetails.tags !== "" ? imgDetails.tags : "",
        notesCommunication: imgDetails.notesCommunication || "",
      };
      setImagesEntity(updatedImageEntity);
      //
    }
  };
  const hoverview = (e, index) => {
    setAftUpload(true);

    if (!aftUpload) return; // Prevent hover logic if 'aftUpload' is false
    if (props.logisticReceiptData.isFetched) {
      const hoverDetails = props.logisticReceiptData.receiptImages[index]; // Get the hovered image by index
      if (hoverDetails) {
        setHoverData(hoverDetails); // Set hover data for the hovered image
      } else {
        setHoverData(new LogisticOrderReceiptImageBean()); // Fallback to default or empty data
      }
    }
    setHover(true); // Set hover state to true when mouse is over the image
  };
  const deleteUploadedImage = (e) => {
    if (e.detail === 1) {
      let url_temp = [];
      url_temp = [...img_Url];
      for (let i = 0; i < url_temp.length; i++) {
        if (i === tempIndex) {
          url_temp.splice(i, 1); // Change the value at index 2
        }
      }
      setImageUrl(url_temp);
      props.deleteMutipleImage(tempIndex);
      setPreviewUrl("");
      setTempImageUrl(url_temp);
      setIndex(null);
      setIsImagePreview(false);
    }
  };
  const onImageChange = (e) => {
    const updatedImageEntity = {
      ...imageEntity, // Spread the existing properties
      [e.target.name]: e.target.value, // Update the property based on input name
    };
    setImagesEntity(updatedImageEntity);
  };
  const addImageLines = (e) => {
    if (e.detail === 1) {
      props.addImageLines(imageEntity);
      props.showToast("Details Uploaded Sucessfully", 1);
    }
  };
  const clearImageLines = (e) => {
    if (e.detail === 1) {
      //props.clearImageLines(imageEntity)

      const updatedImageEntity = {
        ...imageEntity, // Spread the existing properties
        tags: "", // Reset tags
        notesCommunication: "", // Reset notesCommunication
      };
      setImagesEntity(updatedImageEntity);
      props.clearImageLines(updatedImageEntity);
    }
  };
  return (
    // const textAreaStyle = {
    //   maxHeight: "10px",
    //   width: "30%",
    //   minHeight: "5em",
    //   resize: "none",
    //   padding: "9px",
    //   boxSizing: "border-box",
    //   fontSize: "15px",
    // };

    <div className="header_div  div_default">
      <div className="div_inline">
        <div className="div_30_no_overflow">
          <form onSubmit={handleSubmit}>
            <div className="d-flex justify-content-around ">
              <div>
                <label for="imgTag" className="d-flex justify-content-around">
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>

                  <input
                    type="file"
                    className="img-input"
                    id="imgTag"
                    multiple
                    accept="image/*"
                    onChange={handleChange}
                    disabled={disabledImages}
                  />
                </label>
              </div>
              {isImageMainPreview && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle-icon">
                    <button
                      id="fabric_Add_Button"
                      type="submit"
                      //  disabled={isShowDocLabel}
                    >
                      Upload
                    </button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteImage(e)}
                      //   disabled={isShowDocLabel}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>

            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.8rem" }}>
              {!isEmptyArray(img_Url) &&
                img_Url.map((image, index) => (
                  <div key={index} className="column">
                    <div className="effect">
                      <div className="effect-img">
                        <img
                          src={image}
                          alt={`upload-${index}`}
                          style={{
                            width: "100px",
                            height: "100px",
                            border: "1px solid black",
                            marginBottom: "5px", // Space between image and text
                            marginRight: "2px",
                            marginLeft: "2px",
                          }}
                          onClick={(e) => imageview(e, index)}
                          onMouseOver={(e) => hoverview(e, index)}
                          onMouseOut={() => setHover(false)} // Reset hover state on mouse out
                        />
                      </div>
                      {hover == true && (
                        <div className="effect-text">
                          <div class="inner">
                            <p
                            // style={{ fontSize: "12px", margin: 0 }}
                            >
                              {hoverData.imageName}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Index Text Below Image */}
                  </div>
                ))}
            </div>
          </form>
          {/* </div> */}
        </div>
        <div className="div_60_no_overflow">
          {/* <div className="image-preview"> */}

          <form onSubmit={handleEditSubmit}>
            {
              !isEmpty(previewUrl) && (
                <div
                  style={{
                    position: "relative",

                    display: "flex",
                    paddingLeft: "200px",
                  }}
                >
                  <div className="image_grid">
                    {previewUrl != null && (
                      <div
                      // style={{ display: "flex", backgroundColor: "green" }}
                      >
                        <div
                          style={{
                            padding: "10px",
                            width: "100%",
                          }}
                        >
                          <img
                            src={previewUrl}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "200%",
                              float: "left",
                            }}
                          />

                          <label className="d-flex justify-content-around">
                            <div className="d-flex justify-content-around">
                              <span className="img_icon">
                                <CameraIcon />
                              </span>

                              <input
                                type="file"
                                className="img-input"
                                id="imgTag"
                                accept="image/*"
                                onChange={handleImageEditChange}
                                disabled={disabledImages}
                              />

                              <div className="d-flex justify-content-around align-middle">
                                <div className="align-middle">
                                  {isImagePreview && (
                                    <button
                                      id="fabric_Add_Button"
                                      type="submit"
                                      disabled={disabledImages}
                                    >
                                      Upload
                                    </button>
                                  )}
                                </div>
                                <div className="align-middle">
                                  <Button
                                    id="fabric_Add_Button"
                                    onClick={(e) => deleteUploadedImage(e)}
                                    disabled={disabledImages}
                                  >
                                    <DeleteIcon />
                                  </Button>
                                </div>
                              </div>

                              {/* <button
                              type="button"
                              id="fabric_Add_Button"

                            >
                              Remove
                            </button> */}
                            </div>
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      padding: "20px",
                    }}
                  >
                    <Row>
                      <Col sm="2">
                        <FormLabel>Name</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          //  value={imageEntity.imageName}
                          value={imageEntity.imageName || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Created By</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          //value={imageEntity.createdBy}
                          value={imageEntity.createdBy || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>created Date</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          // value={imageEntity.createdDate}
                          value={imageEntity.createdDate || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Tags</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          // value={imageEntity.tags}
                          value={imageEntity.tags || ""}
                          name="tags"
                          // type="text"
                          onChange={onImageChange}
                          disabled={disabledImages}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Notes</FormLabel>
                      </Col>
                      <Col sm="9">
                        <textarea
                          style={{
                            maxHeight: "10px",
                            width: "100%",
                            minHeight: "5em",
                            resize: "none",
                            padding: "9px",
                            boxSizing: "border-box",
                            fontSize: "15px",
                          }}
                          // className="form-control"
                          name="notesCommunication"
                          //  type="text"
                          // placeholder="Notes"
                          onChange={onImageChange}
                          value={imageEntity.notesCommunication || ""}
                          // value={imageEntity.notesCommunication}
                          disabled={disabledImages}
                        />
                        {/* <InputTextbox
                                  value={imgDetails.notesCommunication}
                                // disabled={true}
                                /> */}
                      </Col>
                    </Row>

                    <Row>
                      <Col className="text-center">
                        <Button
                          size="sm"
                          id="fabric_Add_Button"
                          className="header_buttons enterFocus"
                          onClick={(e) => addImageLines(e)}
                          disabled={disabledImages}
                        >
                          Add/Update
                        </Button>
                        <Button
                          id="fabric_Add_Button"
                          size="sm1"
                          onClick={(e) => clearImageLines(e)}
                          disabled={disabledImages}
                        >
                          Clear
                        </Button>
                      </Col>
                    </Row>

                    {/* <p>{`Tags        : ${imgDetails.tags}`}</p>
                              <p>{`Notes       : ${imgDetails.notesCommunication}`}</p> */}
                    {/* </Col> */}
                  </div>
                </div>
              )
              // ))
            }
          </form>
          {/* // </div> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}
export function MutilpleDocuments(props) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewDocs] = useState(props.preview_Docs);
  const [documents, setDocuments] = useState([...props.documents]);
  const [tempIndex, setIndex] = useState(null);
  const documentData = props.logisticReceiptData.logisticOrderReceiptDocuments;
  const [isDocumentUpload, setIsDocumentUpload] = useState(false);

  const disabledImages = props.isServiceLineDisablesFields;
  // useEffect(() => {
  //   setColumns(props.columns);
  // }, [props.columns]);

  const docHandler = (e) => {
    e.preventDefault();
    let tempDocs = e.target.files;
    let doc_list = [];
    let previewList = [];
    if (!isEmptyArray(documents)) {
      doc_list = [...documents];
    }
    if (!isEmptyArray(previewUrl)) {
      previewList = [...previewUrl];
    }
    for (let index = 0; index < tempDocs.length; index++) {
      let docUrl = "";
      doc_list.push(tempDocs[index]);
      docUrl = URL.createObjectURL(tempDocs[index]);
      previewList.push(docUrl);
    }
    setDocuments(doc_list);
    setPreviewDocs(previewList);
    setIsDocumentUpload(true);
  };

  useEffect(() => {
    setDocuments(documents);
  }, [documents]);

  const handleDocumentSubmit = (e) => {
    e.preventDefault();
    props.uploadMutiDouments(documents);
    props.uploadMutiDoumentsUrl(previewUrl);
    props.showToast("Uploaded Sucessfully", 1);
    setIsDocumentUpload(false);
  };
  const deleteDocs = (e) => {
    if (e.detail == 1) {
      setFile(null);
      setPreviewDocs("");
      props.showToast("Image deleted sucessfully", 1);
      setDocuments(props.documents);
      setIsDocumentUpload(false);
    }
  };

  const deleteDocuments = (e, value, rowData) => {
    let documentDataList = documents;
    let fileUrl = previewUrl;
    documentDataList.map((list, index) => {
      if (list.documentName === rowData.documentName) {
        // list.deleted = true;
        // list.isDeleted = true;
        fileUrl.splice(index, 1);
      }
    });
    setPreviewDocs(fileUrl);
    props.uploadMutiDoumentsUrl(fileUrl);
    props.deleteMultiDocument(rowData);
    // setDocuments(documentDataList);
    // setPreviewDocs(fileUrl);
    // props.uploadMutiDouments(documentDataList);
    // props.uploadMutiDoumentsUrl(fileUrl);
  };
  const editDocument = (e, name, tempIndex) => {
    let docUrl = previewUrl;
    let tempUrl = "";
    if (!isEmptyArray(docUrl)) {
      for (let index = 0; index < docUrl.length; index++) {
        if (index === tempIndex) {
          tempUrl = docUrl[index];
        }
      }
      window.open(tempUrl);
    }
  };
  return (
    <div className="header_div  div_default">
      <div className="div_inline">
        {/* <div className="div_80_no_overflow"> */}
        <div className="div_60_no_overflow">
          <div className="div_Equal_no_overflow">
            <form onSubmit={handleDocumentSubmit}>
              <div className="d-flex justify-content-around ">
                <div>
                  <label for="imgTag" className="d-flex justify-content-around">
                    <div className="img_label">
                      Attach Documents
                      <span className="img_icon">
                        <UploadDocIcon />
                      </span>
                    </div>

                    <input
                      type="file"
                      className="img-input"
                      id="imgTag"
                      multiple
                      accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
                      onChange={docHandler}
                      disabled={disabledImages}
                    />
                  </label>
                </div>
                {isDocumentUpload && (
                  <div className="d-flex justify-content-around align-middle">
                    <div className="align-middle">
                      <button
                        id="fabric_Add_Button"
                        type="submit"
                        //  disabled={isShowDocLabel}
                      >
                        Upload
                      </button>
                    </div>
                    <div className="align-middle">
                      <Button
                        id="fabric_Add_Button"
                        onClick={(e) => deleteDocs(e)}
                        // disabled={isShowDocLabel}
                      >
                        <DeleteIcon />
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="div_Custom_3">
        <Table id="fabrics_tables_default">
          <thead>
            <tr>
              <th
              // onClick={(e) =>
              //   props.handleSortingStageDocumentChange(e, "documentName")
              // }
              >
                Document
                {/* {props.order === "desc" &&
                    props.sortField === "documentName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )} */}
              </th>
              <th
              // onClick={(e) =>
              //   props.handleSortingStageDocumentChange(e, "documentName")
              // }
              >
                Document Name
                {/* {props.order === "desc" &&
                    props.sortField === "documentName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )} */}
              </th>
              <th>Delete</th>
            </tr>
          </thead>
          {documentData != null ? (
            <tbody>
              {documentData.map(
                (ln, index) =>
                  ln.isDeleted != true && (
                    <tr key={index}>
                      <td className="hyperLinkText">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            editDocument(e, ln.documentName, index)
                          }
                        >
                          {ln.documentName}
                        </Button>
                      </td>
                      <td>{ln.documentName}</td>
                      <td className="text-right">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            deleteDocuments(e, ln.documentCode, ln)
                          }
                          disabled={disabledImages}
                        >
                          {<DeleteIcon />}
                        </Button>
                      </td>
                    </tr>
                  )
              )}
            </tbody>
          ) : null}
        </Table>
      </div>
      {/* <div className="mt-3">
        <CustomTable
          data={documentData}
          columns={documentColumns()}
          label={"Inquiry Data List"}
        />
      </div> */}
    </div>
  );
}

function LogisticReceiptModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App"></div>
      <LogisticReceipt {...props} name="" />
      <br />
    </div>
  );
}

export default LogisticReceiptModule;
